var map = {
	"./frow": 9,
	"./frow/": 9,
	"./frow/Column": 85,
	"./frow/Column.tsx": 85,
	"./frow/ColumnContext": 170,
	"./frow/ColumnContext.tsx": 170,
	"./frow/Frow": 58,
	"./frow/Frow.tsx": 58,
	"./frow/index": 9,
	"./frow/index.tsx": 9,
	"./interfaces/ConsultancyClient": 1374,
	"./interfaces/ConsultancyClient.tsx": 1374,
	"./interfaces/DataTableTypes": 1375,
	"./interfaces/DataTableTypes.tsx": 1375,
	"./interfaces/FastJsonApiArrayInterface": 1376,
	"./interfaces/FastJsonApiArrayInterface.tsx": 1376,
	"./interfaces/FastJsonApiInterface": 1377,
	"./interfaces/FastJsonApiInterface.tsx": 1377,
	"./interfaces/IActionPointsReview": 1378,
	"./interfaces/IActionPointsReview.tsx": 1378,
	"./interfaces/IAdministrator": 1379,
	"./interfaces/IAdministrator.tsx": 1379,
	"./interfaces/IAdministrators": 1380,
	"./interfaces/IAdministrators.tsx": 1380,
	"./interfaces/IBalance": 1381,
	"./interfaces/IBalance.tsx": 1381,
	"./interfaces/IBalances": 1382,
	"./interfaces/IBalances.tsx": 1382,
	"./interfaces/ICommentaries": 1383,
	"./interfaces/ICommentaries.tsx": 1383,
	"./interfaces/ICommentary": 1384,
	"./interfaces/ICommentary.tsx": 1384,
	"./interfaces/ICompanies": 1385,
	"./interfaces/ICompanies.tsx": 1385,
	"./interfaces/ICompany": 1386,
	"./interfaces/ICompany.tsx": 1386,
	"./interfaces/ICriterionOptions": 1387,
	"./interfaces/ICriterionOptions.tsx": 1387,
	"./interfaces/IEntity": 1388,
	"./interfaces/IEntity.tsx": 1388,
	"./interfaces/IHolding": 1389,
	"./interfaces/IHolding.tsx": 1389,
	"./interfaces/IHoldings": 1390,
	"./interfaces/IHoldings.tsx": 1390,
	"./interfaces/IMandate": 1391,
	"./interfaces/IMandate.tsx": 1391,
	"./interfaces/INote": 1392,
	"./interfaces/INote.tsx": 1392,
	"./interfaces/INotes": 1393,
	"./interfaces/INotes.tsx": 1393,
	"./interfaces/IPortfolio": 1394,
	"./interfaces/IPortfolio.tsx": 1394,
	"./interfaces/IPortfolioBenchmark": 1395,
	"./interfaces/IPortfolioBenchmark.tsx": 1395,
	"./interfaces/IPortfolios": 1396,
	"./interfaces/IPortfolios.tsx": 1396,
	"./interfaces/IReportTemplate": 1397,
	"./interfaces/IReportTemplate.tsx": 1397,
	"./interfaces/IReportTemplates": 1398,
	"./interfaces/IReportTemplates.tsx": 1398,
	"./interfaces/IReview": 1399,
	"./interfaces/IReview.tsx": 1399,
	"./interfaces/IReviewCommentaries": 1400,
	"./interfaces/IReviewCommentaries.tsx": 1400,
	"./interfaces/IReviewCommentary": 1401,
	"./interfaces/IReviewCommentary.tsx": 1401,
	"./interfaces/IReviews": 1402,
	"./interfaces/IReviews.tsx": 1402,
	"./interfaces/ISelectOption": 1403,
	"./interfaces/ISelectOption.tsx": 1403,
	"./interfaces/SecurityInterfaces": 1404,
	"./interfaces/SecurityInterfaces.tsx": 1404,
	"./managerPortal/Reviews": 1405,
	"./managerPortal/Reviews.tsx": 1405,
	"./managerPortal/dashboard/Filters": 1441,
	"./managerPortal/dashboard/Filters.tsx": 1441,
	"./managerPortal/dashboard/Overview": 1460,
	"./managerPortal/dashboard/Overview.tsx": 1460,
	"./managerPortal/dashboard/overview/Graph": 611,
	"./managerPortal/dashboard/overview/Graph.tsx": 611,
	"./managerPortal/dashboard/overview/Numbers": 613,
	"./managerPortal/dashboard/overview/Numbers.tsx": 613,
	"./managerPortal/dashboard/overview/Presenter": 610,
	"./managerPortal/dashboard/overview/Presenter.tsx": 610,
	"./managerPortal/dataUploads/Upload": 1524,
	"./managerPortal/dataUploads/Upload.tsx": 1524,
	"./managerPortal/managers/ApiKey": 1525,
	"./managerPortal/managers/ApiKey.tsx": 1525,
	"./managerPortal/reviews/Presenter": 602,
	"./managerPortal/reviews/Presenter.tsx": 602,
	"./managerPortal/reviews/ReviewBox": 603,
	"./managerPortal/reviews/ReviewBox.tsx": 603,
	"./modals/ModalGraph": 285,
	"./modals/ModalGraph.tsx": 285,
	"./modals/ModalWithTrigger": 195,
	"./modals/ModalWithTrigger.tsx": 195,
	"./modals/ModelModal": 380,
	"./modals/ModelModal.tsx": 380,
	"./modals/context/CloseModal": 237,
	"./modals/context/CloseModal.tsx": 237,
	"./modals/reviews/ActionPointModal": 381,
	"./modals/reviews/ActionPointModal.tsx": 381,
	"./platform/BulkPortfolioImport": 1529,
	"./platform/BulkPortfolioImport.tsx": 1529,
	"./platform/ClientTiles": 1530,
	"./platform/ClientTiles.tsx": 1530,
	"./platform/Commentaries": 1536,
	"./platform/Commentaries.tsx": 1536,
	"./platform/DataChaseTemplates": 1537,
	"./platform/DataChaseTemplates.tsx": 1537,
	"./platform/InvestmentRestrictions": 1538,
	"./platform/InvestmentRestrictions.tsx": 1538,
	"./platform/ReportTemplateBuckets": 1540,
	"./platform/ReportTemplateBuckets.tsx": 1540,
	"./platform/Search": 1589,
	"./platform/Search.tsx": 1589,
	"./platform/Section": 651,
	"./platform/Section.tsx": 651,
	"./platform/TableDataModifier": 1590,
	"./platform/TableDataModifier.tsx": 1590,
	"./platform/TemplateActionPoints": 1591,
	"./platform/TemplateActionPoints.tsx": 1591,
	"./platform/TodoList": 1592,
	"./platform/TodoList.tsx": 1592,
	"./platform/Tracker": 1593,
	"./platform/Tracker.tsx": 1593,
	"./platform/accounting/XeroPostings": 1594,
	"./platform/accounting/XeroPostings.tsx": 1594,
	"./platform/accounting/dashboard/ReviewFilters": 1595,
	"./platform/accounting/dashboard/ReviewFilters.tsx": 1595,
	"./platform/accounting/dashboard/ReviewOverview": 1596,
	"./platform/accounting/dashboard/ReviewOverview.tsx": 1596,
	"./platform/accounting/dashboard/reviewOverview/Presenter": 672,
	"./platform/accounting/dashboard/reviewOverview/Presenter.tsx": 672,
	"./platform/accounting/xeroPostings/ClientRow": 669,
	"./platform/accounting/xeroPostings/ClientRow.tsx": 669,
	"./platform/accounting/xeroPostings/Presenter": 668,
	"./platform/accounting/xeroPostings/Presenter.tsx": 668,
	"./platform/accounting/xeroPostings/clientRow/PortfolioRow": 670,
	"./platform/accounting/xeroPostings/clientRow/PortfolioRow.tsx": 670,
	"./platform/accounting/xeroPostings/clientRow/portfolioRow/ReviewRow": 671,
	"./platform/accounting/xeroPostings/clientRow/portfolioRow/ReviewRow.tsx": 671,
	"./platform/administrators/Table": 1598,
	"./platform/administrators/Table.tsx": 1598,
	"./platform/administrators/permissions/PermissionBreakdown": 392,
	"./platform/administrators/permissions/PermissionBreakdown.tsx": 392,
	"./platform/administrators/permissions/PermissionCheckbox": 678,
	"./platform/administrators/permissions/PermissionCheckbox.tsx": 678,
	"./platform/administrators/permissions/Permissions": 1601,
	"./platform/administrators/permissions/Permissions.tsx": 1601,
	"./platform/administrators/table/columns": 677,
	"./platform/administrators/table/columns.tsx": 677,
	"./platform/assetMappings/Table": 1602,
	"./platform/assetMappings/Table.tsx": 1602,
	"./platform/assetMappings/table/columns": 679,
	"./platform/assetMappings/table/columns.tsx": 679,
	"./platform/audits/AuditDisplay": 680,
	"./platform/audits/AuditDisplay.tsx": 680,
	"./platform/bulkImports/Contacts": 1603,
	"./platform/bulkImports/Contacts.tsx": 1603,
	"./platform/bulkImports/contacts/Contacts": 682,
	"./platform/bulkImports/contacts/Contacts.tsx": 682,
	"./platform/bulkImports/contacts/Presenter": 681,
	"./platform/bulkImports/contacts/Presenter.tsx": 681,
	"./platform/bulkImports/contacts/Summary": 1604,
	"./platform/bulkImports/contacts/Summary.tsx": 1604,
	"./platform/bulkImports/contacts/Table": 1605,
	"./platform/bulkImports/contacts/Table.tsx": 1605,
	"./platform/bulkImports/contacts/UserSelect": 683,
	"./platform/bulkImports/contacts/UserSelect.tsx": 683,
	"./platform/bulkPortfolioImport/Presenter": 624,
	"./platform/bulkPortfolioImport/Presenter.tsx": 624,
	"./platform/bulkPortfolioImport/Summary": 625,
	"./platform/bulkPortfolioImport/Summary.tsx": 625,
	"./platform/bulkPortfolioImport/Table": 626,
	"./platform/bulkPortfolioImport/Table.tsx": 626,
	"./platform/clientTiles/Form": 238,
	"./platform/clientTiles/Form.tsx": 238,
	"./platform/clientTiles/New": 629,
	"./platform/clientTiles/New.tsx": 629,
	"./platform/clientTiles/Tile": 627,
	"./platform/clientTiles/Tile.tsx": 627,
	"./platform/clients/ExtraSettingsUpload": 1606,
	"./platform/clients/ExtraSettingsUpload.tsx": 1606,
	"./platform/clients/FactsheetUpload": 1607,
	"./platform/clients/FactsheetUpload.tsx": 1607,
	"./platform/clients/Form": 1608,
	"./platform/clients/Form.tsx": 1608,
	"./platform/clients/Notes": 1609,
	"./platform/clients/Notes.tsx": 1609,
	"./platform/clients/Show": 1610,
	"./platform/clients/Show.tsx": 1610,
	"./platform/clients/Table": 394,
	"./platform/clients/Table.tsx": 394,
	"./platform/clients/form/AdditionalPortfolioAttributes": 1611,
	"./platform/clients/form/AdditionalPortfolioAttributes.tsx": 1611,
	"./platform/clients/form/ClientFlags": 1612,
	"./platform/clients/form/ClientFlags.tsx": 1612,
	"./platform/clients/form/CommentaryPicker": 1627,
	"./platform/clients/form/CommentaryPicker.tsx": 1627,
	"./platform/clients/form/Documents": 1628,
	"./platform/clients/form/Documents.tsx": 1628,
	"./platform/clients/form/Filename": 1671,
	"./platform/clients/form/Filename.tsx": 1671,
	"./platform/clients/form/Information": 684,
	"./platform/clients/form/Information.tsx": 684,
	"./platform/clients/form/InvestmentRestrictions": 1672,
	"./platform/clients/form/InvestmentRestrictions.tsx": 1672,
	"./platform/clients/form/LetterOfEngagement": 1673,
	"./platform/clients/form/LetterOfEngagement.tsx": 1673,
	"./platform/clients/form/ReportTemplates": 1674,
	"./platform/clients/form/ReportTemplates.tsx": 1674,
	"./platform/clients/form/XeroTenant": 1675,
	"./platform/clients/form/XeroTenant.tsx": 1675,
	"./platform/clients/roles/ClientRoleModal": 692,
	"./platform/clients/roles/ClientRoleModal.tsx": 692,
	"./platform/clients/roles/ClientRoles": 395,
	"./platform/clients/roles/ClientRoles.tsx": 395,
	"./platform/clients/roles/Form": 693,
	"./platform/clients/roles/Form.tsx": 693,
	"./platform/clients/roles/columns": 691,
	"./platform/clients/roles/columns.tsx": 691,
	"./platform/clients/table/columns": 685,
	"./platform/clients/table/columns.tsx": 685,
	"./platform/commentaries/CommentaryDisplay": 630,
	"./platform/commentaries/CommentaryDisplay.tsx": 630,
	"./platform/commentaries/Form": 384,
	"./platform/commentaries/Form.tsx": 384,
	"./platform/commentaries/New": 631,
	"./platform/commentaries/New.tsx": 631,
	"./platform/commentaries/ShortCodes": 1676,
	"./platform/commentaries/ShortCodes.tsx": 1676,
	"./platform/commentaries/shortCodes/Allocation": 705,
	"./platform/commentaries/shortCodes/Allocation.tsx": 705,
	"./platform/commentaries/shortCodes/Performance": 706,
	"./platform/commentaries/shortCodes/Performance.tsx": 706,
	"./platform/commentaries/shortCodes/Rating": 707,
	"./platform/commentaries/shortCodes/Rating.tsx": 707,
	"./platform/companies/Table": 1677,
	"./platform/companies/Table.tsx": 1677,
	"./platform/companies/administrators/Table": 1678,
	"./platform/companies/administrators/Table.tsx": 1678,
	"./platform/companies/administrators/table/Presenter": 709,
	"./platform/companies/administrators/table/Presenter.tsx": 709,
	"./platform/companies/table/Presenter": 708,
	"./platform/companies/table/Presenter.tsx": 708,
	"./platform/consultancyClients/Form": 1679,
	"./platform/consultancyClients/Form.tsx": 1679,
	"./platform/consultancyClients/Table": 1680,
	"./platform/consultancyClients/Table.tsx": 1680,
	"./platform/consultancyClients/table/columns": 710,
	"./platform/consultancyClients/table/columns.tsx": 710,
	"./platform/dashboard/DashSwitcher": 711,
	"./platform/dashboard/DashSwitcher.tsx": 711,
	"./platform/dashboard/ReviewFilters": 1681,
	"./platform/dashboard/ReviewFilters.tsx": 1681,
	"./platform/dashboard/ReviewOverview": 713,
	"./platform/dashboard/ReviewOverview.tsx": 713,
	"./platform/dashboard/reviewFilters/ClientTypeSelect": 286,
	"./platform/dashboard/reviewFilters/ClientTypeSelect.tsx": 286,
	"./platform/dashboard/reviewFilters/Presenter": 712,
	"./platform/dashboard/reviewFilters/Presenter.tsx": 712,
	"./platform/dashboard/reviewFilters/QuarterSelect": 236,
	"./platform/dashboard/reviewFilters/QuarterSelect.tsx": 236,
	"./platform/dashboard/reviewFilters/UserSelect": 391,
	"./platform/dashboard/reviewFilters/UserSelect.tsx": 391,
	"./platform/dashboard/reviewOverview/InfoBox": 337,
	"./platform/dashboard/reviewOverview/InfoBox.tsx": 337,
	"./platform/dashboard/reviewOverview/ItemsByStatus": 715,
	"./platform/dashboard/reviewOverview/ItemsByStatus.tsx": 715,
	"./platform/dashboard/reviewOverview/NextReviewQuarter": 1138,
	"./platform/dashboard/reviewOverview/NextReviewQuarter.tsx": 1138,
	"./platform/dashboard/reviewOverview/Presenter": 714,
	"./platform/dashboard/reviewOverview/Presenter.tsx": 714,
	"./platform/dashboard/reviewOverview/itemsByStatus/Statuses": 716,
	"./platform/dashboard/reviewOverview/itemsByStatus/Statuses.tsx": 716,
	"./platform/dashboard/shared/IFilterOptions": 1682,
	"./platform/dashboard/shared/IFilterOptions.tsx": 1682,
	"./platform/dataChaseTemplates/Emails": 633,
	"./platform/dataChaseTemplates/Emails.tsx": 633,
	"./platform/dataChaseTemplates/Presenter": 632,
	"./platform/dataChaseTemplates/Presenter.tsx": 632,
	"./platform/dataChaseTemplates/Template": 634,
	"./platform/dataChaseTemplates/Template.tsx": 634,
	"./platform/dataChaseTemplates/emails/Summary": 448,
	"./platform/dataChaseTemplates/emails/Summary.tsx": 448,
	"./platform/dataUploads/Table": 1683,
	"./platform/dataUploads/Table.tsx": 1683,
	"./platform/dataUploads/table/columns": 717,
	"./platform/dataUploads/table/columns.tsx": 717,
	"./platform/entities/Form": 1684,
	"./platform/entities/Form.tsx": 1684,
	"./platform/entities/Structure": 1686,
	"./platform/entities/Structure.tsx": 1686,
	"./platform/entities/Table": 1687,
	"./platform/entities/Table.tsx": 1687,
	"./platform/entities/form/EntitySelect": 1688,
	"./platform/entities/form/EntitySelect.tsx": 1688,
	"./platform/entities/form/Presenter": 718,
	"./platform/entities/form/Presenter.tsx": 718,
	"./platform/entities/form/fieldsets/Address": 401,
	"./platform/entities/form/fieldsets/Address.tsx": 401,
	"./platform/entities/form/fieldsets/Aml": 719,
	"./platform/entities/form/fieldsets/Aml.tsx": 719,
	"./platform/entities/form/fieldsets/Customer": 720,
	"./platform/entities/form/fieldsets/Customer.tsx": 720,
	"./platform/entities/form/fieldsets/Legal": 721,
	"./platform/entities/form/fieldsets/Legal.tsx": 721,
	"./platform/entities/form/fieldsets/Natural": 722,
	"./platform/entities/form/fieldsets/Natural.tsx": 722,
	"./platform/entities/structure/Entity": 725,
	"./platform/entities/structure/Entity.tsx": 725,
	"./platform/entities/structure/EntityLevels": 724,
	"./platform/entities/structure/EntityLevels.tsx": 724,
	"./platform/entities/structure/Presenter": 723,
	"./platform/entities/structure/Presenter.tsx": 723,
	"./platform/entities/table/columns": 726,
	"./platform/entities/table/columns.tsx": 726,
	"./platform/entityRelationshipRoles/Table": 1689,
	"./platform/entityRelationshipRoles/Table.tsx": 1689,
	"./platform/entityRelationshipRoles/table/columns": 727,
	"./platform/entityRelationshipRoles/table/columns.tsx": 727,
	"./platform/extracts/Create": 728,
	"./platform/extracts/Create.tsx": 728,
	"./platform/extracts/Table": 1690,
	"./platform/extracts/Table.tsx": 1690,
	"./platform/extracts/create/SliceAndDice": 729,
	"./platform/extracts/create/SliceAndDice.tsx": 729,
	"./platform/extracts/table/columns": 730,
	"./platform/extracts/table/columns.tsx": 730,
	"./platform/holdings/MissingLiveSecurityStatesTable": 1691,
	"./platform/holdings/MissingLiveSecurityStatesTable.tsx": 1691,
	"./platform/investmentRestrictions/Table": 1137,
	"./platform/investmentRestrictions/Table.tsx": 1137,
	"./platform/investmentRiskAssessments/Form": 1692,
	"./platform/investmentRiskAssessments/Form.tsx": 1692,
	"./platform/investmentRiskAssessments/Table": 686,
	"./platform/investmentRiskAssessments/Table.tsx": 686,
	"./platform/investmentRiskAssessments/table/Destroy": 688,
	"./platform/investmentRiskAssessments/table/Destroy.tsx": 688,
	"./platform/investmentRiskAssessments/table/columns": 687,
	"./platform/investmentRiskAssessments/table/columns.tsx": 687,
	"./platform/layouts/Notifications": 1963,
	"./platform/layouts/Notifications.tsx": 1963,
	"./platform/layouts/TrackedJobs": 1693,
	"./platform/layouts/TrackedJobs.tsx": 1693,
	"./platform/layouts/notifications/Notification": 403,
	"./platform/layouts/notifications/Notification.tsx": 403,
	"./platform/layouts/notifications/Presenter": 731,
	"./platform/layouts/notifications/Presenter.tsx": 731,
	"./platform/layouts/trackedJobs/Presenter": 732,
	"./platform/layouts/trackedJobs/Presenter.tsx": 732,
	"./platform/layouts/trackedJobs/TrackedJob": 734,
	"./platform/layouts/trackedJobs/TrackedJob.tsx": 734,
	"./platform/managerUploads/Table": 1694,
	"./platform/managerUploads/Table.tsx": 1694,
	"./platform/managerUploads/table/columns": 735,
	"./platform/managerUploads/table/columns.tsx": 735,
	"./platform/managerUsers/Table": 736,
	"./platform/managerUsers/Table.tsx": 736,
	"./platform/managerUsers/table/columns": 737,
	"./platform/managerUsers/table/columns.tsx": 737,
	"./platform/managers/Notes": 1695,
	"./platform/managers/Notes.tsx": 1695,
	"./platform/managers/Show": 1696,
	"./platform/managers/Show.tsx": 1696,
	"./platform/managers/Table": 1697,
	"./platform/managers/Table.tsx": 1697,
	"./platform/managers/dataUploads/Show": 1698,
	"./platform/managers/dataUploads/Show.tsx": 1698,
	"./platform/managers/dataUploads/show/FileDownload": 744,
	"./platform/managers/dataUploads/show/FileDownload.tsx": 744,
	"./platform/managers/dataUploads/show/Messages": 507,
	"./platform/managers/dataUploads/show/Messages.tsx": 507,
	"./platform/managers/dataUploads/show/Notes": 745,
	"./platform/managers/dataUploads/show/Notes.tsx": 745,
	"./platform/managers/dataUploads/show/Presenter": 742,
	"./platform/managers/dataUploads/show/Presenter.tsx": 742,
	"./platform/managers/dataUploads/show/ReProcess": 746,
	"./platform/managers/dataUploads/show/ReProcess.tsx": 746,
	"./platform/managers/dataUploads/show/messages/Table": 743,
	"./platform/managers/dataUploads/show/messages/Table.tsx": 743,
	"./platform/managers/dataUploads/show/messages/table/ErrorMessagesColumns": 747,
	"./platform/managers/dataUploads/show/messages/table/ErrorMessagesColumns.tsx": 747,
	"./platform/managers/dataUploads/show/messages/table/InformationalMessagesColumns": 749,
	"./platform/managers/dataUploads/show/messages/table/InformationalMessagesColumns.tsx": 749,
	"./platform/managers/dataUploads/show/messages/table/Resolve": 748,
	"./platform/managers/dataUploads/show/messages/table/Resolve.tsx": 748,
	"./platform/managers/dataUploads/show/notes/Form": 287,
	"./platform/managers/dataUploads/show/notes/Form.tsx": 287,
	"./platform/managers/notes/Attachments": 750,
	"./platform/managers/notes/Attachments.tsx": 750,
	"./platform/managers/notes/Edit": 1699,
	"./platform/managers/notes/Edit.tsx": 1699,
	"./platform/managers/notes/Form": 1700,
	"./platform/managers/notes/Form.tsx": 1700,
	"./platform/managers/table/columns": 741,
	"./platform/managers/table/columns.tsx": 741,
	"./platform/managers/uploadTemplates/Edit": 1701,
	"./platform/managers/uploadTemplates/Edit.tsx": 1701,
	"./platform/managers/uploadTemplates/Upload": 1702,
	"./platform/managers/uploadTemplates/Upload.tsx": 1702,
	"./platform/managers/uploadTemplates/edit/Context": 162,
	"./platform/managers/uploadTemplates/edit/Context.tsx": 162,
	"./platform/managers/uploadTemplates/edit/Presenter": 751,
	"./platform/managers/uploadTemplates/edit/Presenter.tsx": 751,
	"./platform/managers/uploadTemplates/edit/Sheets": 753,
	"./platform/managers/uploadTemplates/edit/Sheets.tsx": 753,
	"./platform/managers/uploadTemplates/edit/Template": 752,
	"./platform/managers/uploadTemplates/edit/Template.tsx": 752,
	"./platform/managers/uploadTemplates/edit/sheets/Attributes": 755,
	"./platform/managers/uploadTemplates/edit/sheets/Attributes.tsx": 755,
	"./platform/managers/uploadTemplates/edit/sheets/Columns": 763,
	"./platform/managers/uploadTemplates/edit/sheets/Columns.tsx": 763,
	"./platform/managers/uploadTemplates/edit/sheets/Conditions": 443,
	"./platform/managers/uploadTemplates/edit/sheets/Conditions.tsx": 443,
	"./platform/managers/uploadTemplates/edit/sheets/TemplateSheet": 754,
	"./platform/managers/uploadTemplates/edit/sheets/TemplateSheet.tsx": 754,
	"./platform/managers/uploadTemplates/edit/sheets/attributes/Attribute": 756,
	"./platform/managers/uploadTemplates/edit/sheets/attributes/Attribute.tsx": 756,
	"./platform/managers/uploadTemplates/edit/sheets/columns/DataFormat": 766,
	"./platform/managers/uploadTemplates/edit/sheets/columns/DataFormat.tsx": 766,
	"./platform/managers/uploadTemplates/edit/sheets/columns/Options": 765,
	"./platform/managers/uploadTemplates/edit/sheets/columns/Options.tsx": 765,
	"./platform/managers/uploadTemplates/edit/sheets/columns/TemplateSheetColumn": 764,
	"./platform/managers/uploadTemplates/edit/sheets/columns/TemplateSheetColumn.tsx": 764,
	"./platform/managers/uploadTemplates/edit/sheets/conditions/ChangeDate": 758,
	"./platform/managers/uploadTemplates/edit/sheets/conditions/ChangeDate.tsx": 758,
	"./platform/managers/uploadTemplates/edit/sheets/conditions/Condition": 757,
	"./platform/managers/uploadTemplates/edit/sheets/conditions/Condition.tsx": 757,
	"./platform/managers/uploadTemplates/edit/sheets/conditions/MatchColumn": 759,
	"./platform/managers/uploadTemplates/edit/sheets/conditions/MatchColumn.tsx": 759,
	"./platform/managers/uploadTemplates/edit/sheets/conditions/MatchCondition": 761,
	"./platform/managers/uploadTemplates/edit/sheets/conditions/MatchCondition.tsx": 761,
	"./platform/managers/uploadTemplates/edit/sheets/conditions/PotentiallyBlank": 762,
	"./platform/managers/uploadTemplates/edit/sheets/conditions/PotentiallyBlank.tsx": 762,
	"./platform/managers/uploadTemplates/edit/sheets/conditions/matchColumn/Conditions": 760,
	"./platform/managers/uploadTemplates/edit/sheets/conditions/matchColumn/Conditions.tsx": 760,
	"./platform/managers/uploadTemplates/upload/Presenter": 767,
	"./platform/managers/uploadTemplates/upload/Presenter.tsx": 767,
	"./platform/marketCommentaries/Table": 1703,
	"./platform/marketCommentaries/Table.tsx": 1703,
	"./platform/marketCommentaries/table/columns": 768,
	"./platform/marketCommentaries/table/columns.tsx": 768,
	"./platform/navOneClients/Table": 1704,
	"./platform/navOneClients/Table.tsx": 1704,
	"./platform/notifications/List": 1705,
	"./platform/notifications/List.tsx": 1705,
	"./platform/notifications/list/Presenter": 769,
	"./platform/notifications/list/Presenter.tsx": 769,
	"./platform/parentManagers/Table": 1706,
	"./platform/parentManagers/Table.tsx": 1706,
	"./platform/parentManagers/table/columns": 770,
	"./platform/parentManagers/table/columns.tsx": 770,
	"./platform/portfolioBenchmarks/AssignBenchmarkToPortfolio": 1707,
	"./platform/portfolioBenchmarks/AssignBenchmarkToPortfolio.tsx": 1707,
	"./platform/portfolioBenchmarks/Form": 1708,
	"./platform/portfolioBenchmarks/Form.tsx": 1708,
	"./platform/portfolioBenchmarks/Show": 1709,
	"./platform/portfolioBenchmarks/Show.tsx": 1709,
	"./platform/portfolioBenchmarks/Table": 1710,
	"./platform/portfolioBenchmarks/Table.tsx": 1710,
	"./platform/portfolioBenchmarks/Upload": 1711,
	"./platform/portfolioBenchmarks/Upload.tsx": 1711,
	"./platform/portfolioBenchmarks/form/Composite": 775,
	"./platform/portfolioBenchmarks/form/Composite.tsx": 775,
	"./platform/portfolioBenchmarks/form/Presenter": 771,
	"./platform/portfolioBenchmarks/form/Presenter.tsx": 771,
	"./platform/portfolioBenchmarks/form/Reference": 773,
	"./platform/portfolioBenchmarks/form/Reference.tsx": 773,
	"./platform/portfolioBenchmarks/form/Surfaceable": 774,
	"./platform/portfolioBenchmarks/form/Surfaceable.tsx": 774,
	"./platform/portfolioBenchmarks/form/composite/ComponentBenchmark": 777,
	"./platform/portfolioBenchmarks/form/composite/ComponentBenchmark.tsx": 777,
	"./platform/portfolioBenchmarks/form/composite/ComponentBenchmarks": 776,
	"./platform/portfolioBenchmarks/form/composite/ComponentBenchmarks.tsx": 776,
	"./platform/portfolioBenchmarks/form/composite/SelectedBenchmark": 778,
	"./platform/portfolioBenchmarks/form/composite/SelectedBenchmark.tsx": 778,
	"./platform/portfolioBenchmarks/portfolios/Table": 1712,
	"./platform/portfolioBenchmarks/portfolios/Table.tsx": 1712,
	"./platform/portfolioBenchmarks/show/Chart": 780,
	"./platform/portfolioBenchmarks/show/Chart.tsx": 780,
	"./platform/portfolioBenchmarks/show/Metric": 508,
	"./platform/portfolioBenchmarks/show/Metric.tsx": 508,
	"./platform/portfolioBenchmarks/show/Presenter": 779,
	"./platform/portfolioBenchmarks/show/Presenter.tsx": 779,
	"./platform/portfolioBenchmarks/show/Regenerate": 1713,
	"./platform/portfolioBenchmarks/show/Regenerate.tsx": 1713,
	"./platform/portfolioBenchmarks/show/Table": 783,
	"./platform/portfolioBenchmarks/show/Table.tsx": 783,
	"./platform/portfolioBenchmarks/show/Upload": 1714,
	"./platform/portfolioBenchmarks/show/Upload.tsx": 1714,
	"./platform/portfolioBenchmarks/show/table/columns": 784,
	"./platform/portfolioBenchmarks/show/table/columns.tsx": 784,
	"./platform/portfolioBenchmarks/table/StatusIndicator": 787,
	"./platform/portfolioBenchmarks/table/StatusIndicator.tsx": 787,
	"./platform/portfolioBenchmarks/table/columns": 786,
	"./platform/portfolioBenchmarks/table/columns.tsx": 786,
	"./platform/portfolios/Details": 1715,
	"./platform/portfolios/Details.tsx": 1715,
	"./platform/portfolios/Form": 1720,
	"./platform/portfolios/Form.tsx": 1720,
	"./platform/portfolios/Show": 1721,
	"./platform/portfolios/Show.tsx": 1721,
	"./platform/portfolios/Table": 245,
	"./platform/portfolios/Table.tsx": 245,
	"./platform/portfolios/details/InfoBar": 789,
	"./platform/portfolios/details/InfoBar.tsx": 789,
	"./platform/portfolios/details/PortfolioInfo": 798,
	"./platform/portfolios/details/PortfolioInfo.tsx": 798,
	"./platform/portfolios/details/PortfolioSelect": 807,
	"./platform/portfolios/details/PortfolioSelect.tsx": 807,
	"./platform/portfolios/details/Presenter": 788,
	"./platform/portfolios/details/Presenter.tsx": 788,
	"./platform/portfolios/details/QuickSearch": 808,
	"./platform/portfolios/details/QuickSearch.tsx": 808,
	"./platform/portfolios/details/UseInvestmentPolicyStatementModal": 805,
	"./platform/portfolios/details/UseInvestmentPolicyStatementModal.tsx": 805,
	"./platform/portfolios/details/UseMandateModal": 806,
	"./platform/portfolios/details/UseMandateModal.tsx": 806,
	"./platform/portfolios/details/infoBar/Destroy": 790,
	"./platform/portfolios/details/infoBar/Destroy.tsx": 790,
	"./platform/portfolios/details/infoBar/ManualUpload": 791,
	"./platform/portfolios/details/infoBar/ManualUpload.tsx": 791,
	"./platform/portfolios/details/infoBar/RegenerateReturns": 793,
	"./platform/portfolios/details/infoBar/RegenerateReturns.tsx": 793,
	"./platform/portfolios/details/infoBar/Terminate": 794,
	"./platform/portfolios/details/infoBar/Terminate.tsx": 794,
	"./platform/portfolios/details/infoBar/manualEntry": 1139,
	"./platform/portfolios/details/infoBar/manualEntry.tsx": 1139,
	"./platform/portfolios/details/infoBar/manualEntry/DataNotes": 796,
	"./platform/portfolios/details/infoBar/manualEntry/DataNotes.tsx": 796,
	"./platform/portfolios/details/infoBar/manualEntry/DataTable": 343,
	"./platform/portfolios/details/infoBar/manualEntry/DataTable.tsx": 343,
	"./platform/portfolios/details/infoBar/manualEntry/NewRow": 795,
	"./platform/portfolios/details/infoBar/manualEntry/NewRow.tsx": 795,
	"./platform/portfolios/details/infoBar/manualEntry/ScratchPad": 1140,
	"./platform/portfolios/details/infoBar/manualEntry/ScratchPad.tsx": 1140,
	"./platform/portfolios/details/infoBar/manualEntry/tab": 797,
	"./platform/portfolios/details/infoBar/manualEntry/tab.tsx": 797,
	"./platform/portfolios/details/infoBar/manualUpload/Uploader": 792,
	"./platform/portfolios/details/infoBar/manualUpload/Uploader.tsx": 792,
	"./platform/portfolios/details/portfolioInfo/ExtraSettings": 799,
	"./platform/portfolios/details/portfolioInfo/ExtraSettings.tsx": 799,
	"./platform/portfolios/details/portfolioInfo/LinkedBenchmarks": 800,
	"./platform/portfolios/details/portfolioInfo/LinkedBenchmarks.tsx": 800,
	"./platform/portfolios/details/portfolioInfo/MandateFlags": 804,
	"./platform/portfolios/details/portfolioInfo/MandateFlags.tsx": 804,
	"./platform/portfolios/details/portfolioInfo/MandateInformation": 801,
	"./platform/portfolios/details/portfolioInfo/MandateInformation.tsx": 801,
	"./platform/portfolios/details/portfolioInfo/PlatformPerformanceChart": 802,
	"./platform/portfolios/details/portfolioInfo/PlatformPerformanceChart.tsx": 802,
	"./platform/portfolios/details/portfolioInfo/Section": 210,
	"./platform/portfolios/details/portfolioInfo/Section.tsx": 210,
	"./platform/portfolios/details/shared/StatusTag": 338,
	"./platform/portfolios/details/shared/StatusTag.tsx": 338,
	"./platform/portfolios/form/Benchmarks": 810,
	"./platform/portfolios/form/Benchmarks.tsx": 810,
	"./platform/portfolios/form/Confirm": 812,
	"./platform/portfolios/form/Confirm.tsx": 812,
	"./platform/portfolios/form/Context": 52,
	"./platform/portfolios/form/Context.tsx": 52,
	"./platform/portfolios/form/DocumentUploader": 451,
	"./platform/portfolios/form/DocumentUploader.tsx": 451,
	"./platform/portfolios/form/Documents": 813,
	"./platform/portfolios/form/Documents.tsx": 813,
	"./platform/portfolios/form/ExtraSettings": 814,
	"./platform/portfolios/form/ExtraSettings.tsx": 814,
	"./platform/portfolios/form/Information": 815,
	"./platform/portfolios/form/Information.tsx": 815,
	"./platform/portfolios/form/Mandate": 828,
	"./platform/portfolios/form/Mandate.tsx": 828,
	"./platform/portfolios/form/Nav": 839,
	"./platform/portfolios/form/Nav.tsx": 839,
	"./platform/portfolios/form/Presenter": 809,
	"./platform/portfolios/form/Presenter.tsx": 809,
	"./platform/portfolios/form/Service": 840,
	"./platform/portfolios/form/Service.tsx": 840,
	"./platform/portfolios/form/Submitting": 291,
	"./platform/portfolios/form/Submitting.tsx": 291,
	"./platform/portfolios/form/benchmarks/Presenter": 811,
	"./platform/portfolios/form/benchmarks/Presenter.tsx": 811,
	"./platform/portfolios/form/benchmarks/Row": 509,
	"./platform/portfolios/form/benchmarks/Row.tsx": 509,
	"./platform/portfolios/form/benchmarks/Select": 510,
	"./platform/portfolios/form/benchmarks/Select.tsx": 510,
	"./platform/portfolios/form/information/AdminInfo": 816,
	"./platform/portfolios/form/information/AdminInfo.tsx": 816,
	"./platform/portfolios/form/information/Client": 817,
	"./platform/portfolios/form/information/Client.tsx": 817,
	"./platform/portfolios/form/information/Contacts": 818,
	"./platform/portfolios/form/information/Contacts.tsx": 818,
	"./platform/portfolios/form/information/DataChase": 820,
	"./platform/portfolios/form/information/DataChase.tsx": 820,
	"./platform/portfolios/form/information/Entity": 821,
	"./platform/portfolios/form/information/Entity.tsx": 821,
	"./platform/portfolios/form/information/Manager": 826,
	"./platform/portfolios/form/information/Manager.tsx": 826,
	"./platform/portfolios/form/information/contacts/ContactCreate": 819,
	"./platform/portfolios/form/information/contacts/ContactCreate.tsx": 819,
	"./platform/portfolios/form/information/entity/Combined": 824,
	"./platform/portfolios/form/information/entity/Combined.tsx": 824,
	"./platform/portfolios/form/information/entity/Consolidated": 825,
	"./platform/portfolios/form/information/entity/Consolidated.tsx": 825,
	"./platform/portfolios/form/information/entity/EntityCreate": 822,
	"./platform/portfolios/form/information/entity/EntityCreate.tsx": 822,
	"./platform/portfolios/form/information/entity/EntitySelect": 823,
	"./platform/portfolios/form/information/entity/EntitySelect.tsx": 823,
	"./platform/portfolios/form/information/entity/shared/ChildPortfolioSelect": 406,
	"./platform/portfolios/form/information/entity/shared/ChildPortfolioSelect.tsx": 406,
	"./platform/portfolios/form/information/manager/ManagerCreate": 827,
	"./platform/portfolios/form/information/manager/ManagerCreate.tsx": 827,
	"./platform/portfolios/form/mandate/Charges": 829,
	"./platform/portfolios/form/mandate/Charges.tsx": 829,
	"./platform/portfolios/form/mandate/DocumentInfo": 830,
	"./platform/portfolios/form/mandate/DocumentInfo.tsx": 830,
	"./platform/portfolios/form/mandate/MandateFlags": 838,
	"./platform/portfolios/form/mandate/MandateFlags.tsx": 838,
	"./platform/portfolios/form/mandate/Objectives": 831,
	"./platform/portfolios/form/mandate/Objectives.tsx": 831,
	"./platform/portfolios/form/mandate/RiskCurrency": 832,
	"./platform/portfolios/form/mandate/RiskCurrency.tsx": 832,
	"./platform/portfolios/form/mandate/StrategicAllocation": 833,
	"./platform/portfolios/form/mandate/StrategicAllocation.tsx": 833,
	"./platform/portfolios/form/mandate/TacticalAllocations": 836,
	"./platform/portfolios/form/mandate/TacticalAllocations.tsx": 836,
	"./platform/portfolios/form/mandate/strategicAssetAllocations/AssetSlider": 835,
	"./platform/portfolios/form/mandate/strategicAssetAllocations/AssetSlider.tsx": 835,
	"./platform/portfolios/form/mandate/tacticalAllocations/Asset": 837,
	"./platform/portfolios/form/mandate/tacticalAllocations/Asset.tsx": 837,
	"./platform/portfolios/form/service/CommentaryPicker": 843,
	"./platform/portfolios/form/service/CommentaryPicker.tsx": 843,
	"./platform/portfolios/form/service/DataFrequencyPicker": 842,
	"./platform/portfolios/form/service/DataFrequencyPicker.tsx": 842,
	"./platform/portfolios/form/service/Information": 841,
	"./platform/portfolios/form/service/Information.tsx": 841,
	"./platform/portfolios/form/service/RelationshipManager": 844,
	"./platform/portfolios/form/service/RelationshipManager.tsx": 844,
	"./platform/portfolios/performanceNumbers/Edit": 1724,
	"./platform/portfolios/performanceNumbers/Edit.tsx": 1724,
	"./platform/portfolios/performanceNumbers/edit/Presenter": 916,
	"./platform/portfolios/performanceNumbers/edit/Presenter.tsx": 916,
	"./platform/portfolios/reviews/Commentaries": 1725,
	"./platform/portfolios/reviews/Commentaries.tsx": 1725,
	"./platform/portfolios/reviews/commentaries/BespokeCommentary": 920,
	"./platform/portfolios/reviews/commentaries/BespokeCommentary.tsx": 920,
	"./platform/portfolios/reviews/commentaries/LongForm": 918,
	"./platform/portfolios/reviews/commentaries/LongForm.tsx": 918,
	"./platform/portfolios/reviews/commentaries/Presenter": 917,
	"./platform/portfolios/reviews/commentaries/Presenter.tsx": 917,
	"./platform/portfolios/reviews/commentaries/SectionCommentary": 311,
	"./platform/portfolios/reviews/commentaries/SectionCommentary.tsx": 311,
	"./platform/portfolios/reviews/commentaries/Standard": 919,
	"./platform/portfolios/reviews/commentaries/Standard.tsx": 919,
	"./platform/portfolios/reviews/reports/Preview": 1726,
	"./platform/portfolios/reviews/reports/Preview.tsx": 1726,
	"./platform/portfolios/show/Context": 50,
	"./platform/portfolios/show/Context.tsx": 50,
	"./platform/portfolios/show/PortfolioData": 846,
	"./platform/portfolios/show/PortfolioData.tsx": 846,
	"./platform/portfolios/show/PortfolioSectionSelect": 866,
	"./platform/portfolios/show/PortfolioSectionSelect.tsx": 866,
	"./platform/portfolios/show/Presenter": 845,
	"./platform/portfolios/show/Presenter.tsx": 845,
	"./platform/portfolios/show/portfolioData/Allocations": 847,
	"./platform/portfolios/show/portfolioData/Allocations.tsx": 847,
	"./platform/portfolios/show/portfolioData/Balances": 858,
	"./platform/portfolios/show/portfolioData/Balances.tsx": 858,
	"./platform/portfolios/show/portfolioData/Reviews": 867,
	"./platform/portfolios/show/portfolioData/Reviews.tsx": 867,
	"./platform/portfolios/show/portfolioData/allocations/AssetColumns": 849,
	"./platform/portfolios/show/portfolioData/allocations/AssetColumns.tsx": 849,
	"./platform/portfolios/show/portfolioData/allocations/Assets": 848,
	"./platform/portfolios/show/portfolioData/allocations/Assets.tsx": 848,
	"./platform/portfolios/show/portfolioData/allocations/Currencies": 850,
	"./platform/portfolios/show/portfolioData/allocations/Currencies.tsx": 850,
	"./platform/portfolios/show/portfolioData/allocations/CurrencyColumns": 851,
	"./platform/portfolios/show/portfolioData/allocations/CurrencyColumns.tsx": 851,
	"./platform/portfolios/show/portfolioData/allocations/Holdings": 852,
	"./platform/portfolios/show/portfolioData/allocations/Holdings.tsx": 852,
	"./platform/portfolios/show/portfolioData/allocations/HoldingsColumns": 853,
	"./platform/portfolios/show/portfolioData/allocations/HoldingsColumns.tsx": 853,
	"./platform/portfolios/show/portfolioData/allocations/PrivateAssets": 854,
	"./platform/portfolios/show/portfolioData/allocations/PrivateAssets.tsx": 854,
	"./platform/portfolios/show/portfolioData/allocations/PrivateAssetsColumns": 855,
	"./platform/portfolios/show/portfolioData/allocations/PrivateAssetsColumns.tsx": 855,
	"./platform/portfolios/show/portfolioData/allocations/privateAssets/PrivateAssetForm": 407,
	"./platform/portfolios/show/portfolioData/allocations/privateAssets/PrivateAssetForm.tsx": 407,
	"./platform/portfolios/show/portfolioData/allocations/privateAssets/privateAssetForm/BalanceInput": 856,
	"./platform/portfolios/show/portfolioData/allocations/privateAssets/privateAssetForm/BalanceInput.tsx": 856,
	"./platform/portfolios/show/portfolioData/allocations/privateAssets/privateAssetForm/table/Columns": 857,
	"./platform/portfolios/show/portfolioData/allocations/privateAssets/privateAssetForm/table/Columns.tsx": 857,
	"./platform/portfolios/show/portfolioData/balances/BalanceMetric": 862,
	"./platform/portfolios/show/portfolioData/balances/BalanceMetric.tsx": 862,
	"./platform/portfolios/show/portfolioData/balances/Chart": 860,
	"./platform/portfolios/show/portfolioData/balances/Chart.tsx": 860,
	"./platform/portfolios/show/portfolioData/balances/OverallReturnMetric": 864,
	"./platform/portfolios/show/portfolioData/balances/OverallReturnMetric.tsx": 864,
	"./platform/portfolios/show/portfolioData/balances/Presenter": 859,
	"./platform/portfolios/show/portfolioData/balances/Presenter.tsx": 859,
	"./platform/portfolios/show/portfolioData/balances/QuarterlyReturnMetric": 863,
	"./platform/portfolios/show/portfolioData/balances/QuarterlyReturnMetric.tsx": 863,
	"./platform/portfolios/show/portfolioData/balances/Table": 861,
	"./platform/portfolios/show/portfolioData/balances/Table.tsx": 861,
	"./platform/portfolios/show/portfolioData/balances/table/Columns": 865,
	"./platform/portfolios/show/portfolioData/balances/table/Columns.tsx": 865,
	"./platform/portfolios/show/portfolioData/reviews/NewReview": 876,
	"./platform/portfolios/show/portfolioData/reviews/NewReview.tsx": 876,
	"./platform/portfolios/show/portfolioData/reviews/Notes": 868,
	"./platform/portfolios/show/portfolioData/reviews/Notes.tsx": 868,
	"./platform/portfolios/show/portfolioData/reviews/ReviewSelector": 875,
	"./platform/portfolios/show/portfolioData/reviews/ReviewSelector.tsx": 875,
	"./platform/portfolios/show/portfolioData/reviews/Show": 877,
	"./platform/portfolios/show/portfolioData/reviews/Show.tsx": 877,
	"./platform/portfolios/show/portfolioData/reviews/notes/Attachments": 872,
	"./platform/portfolios/show/portfolioData/reviews/notes/Attachments.tsx": 872,
	"./platform/portfolios/show/portfolioData/reviews/notes/Edit": 871,
	"./platform/portfolios/show/portfolioData/reviews/notes/Edit.tsx": 871,
	"./platform/portfolios/show/portfolioData/reviews/notes/Form": 408,
	"./platform/portfolios/show/portfolioData/reviews/notes/Form.tsx": 408,
	"./platform/portfolios/show/portfolioData/reviews/notes/NewNote": 874,
	"./platform/portfolios/show/portfolioData/reviews/notes/NewNote.tsx": 874,
	"./platform/portfolios/show/portfolioData/reviews/notes/PortfolioSelect": 873,
	"./platform/portfolios/show/portfolioData/reviews/notes/PortfolioSelect.tsx": 873,
	"./platform/portfolios/show/portfolioData/reviews/show/ActionPoints": 879,
	"./platform/portfolios/show/portfolioData/reviews/show/ActionPoints.tsx": 879,
	"./platform/portfolios/show/portfolioData/reviews/show/Answers": 882,
	"./platform/portfolios/show/portfolioData/reviews/show/Answers.tsx": 882,
	"./platform/portfolios/show/portfolioData/reviews/show/Commentary": 884,
	"./platform/portfolios/show/portfolioData/reviews/show/Commentary.tsx": 884,
	"./platform/portfolios/show/portfolioData/reviews/show/Comments": 885,
	"./platform/portfolios/show/portfolioData/reviews/show/Comments.tsx": 885,
	"./platform/portfolios/show/portfolioData/reviews/show/Data": 887,
	"./platform/portfolios/show/portfolioData/reviews/show/Data.tsx": 887,
	"./platform/portfolios/show/portfolioData/reviews/show/DeleteReview": 896,
	"./platform/portfolios/show/portfolioData/reviews/show/DeleteReview.tsx": 896,
	"./platform/portfolios/show/portfolioData/reviews/show/GeneratedReports": 897,
	"./platform/portfolios/show/portfolioData/reviews/show/GeneratedReports.tsx": 897,
	"./platform/portfolios/show/portfolioData/reviews/show/Graph": 888,
	"./platform/portfolios/show/portfolioData/reviews/show/Graph.tsx": 888,
	"./platform/portfolios/show/portfolioData/reviews/show/History": 898,
	"./platform/portfolios/show/portfolioData/reviews/show/History.tsx": 898,
	"./platform/portfolios/show/portfolioData/reviews/show/Info": 900,
	"./platform/portfolios/show/portfolioData/reviews/show/Info.tsx": 900,
	"./platform/portfolios/show/portfolioData/reviews/show/Overview": 902,
	"./platform/portfolios/show/portfolioData/reviews/show/Overview.tsx": 902,
	"./platform/portfolios/show/portfolioData/reviews/show/Presenter": 878,
	"./platform/portfolios/show/portfolioData/reviews/show/Presenter.tsx": 878,
	"./platform/portfolios/show/portfolioData/reviews/show/Preview": 908,
	"./platform/portfolios/show/portfolioData/reviews/show/Preview.tsx": 908,
	"./platform/portfolios/show/portfolioData/reviews/show/Rating": 903,
	"./platform/portfolios/show/portfolioData/reviews/show/Rating.tsx": 903,
	"./platform/portfolios/show/portfolioData/reviews/show/Reports": 906,
	"./platform/portfolios/show/portfolioData/reviews/show/Reports.tsx": 906,
	"./platform/portfolios/show/portfolioData/reviews/show/ReviewContext": 48,
	"./platform/portfolios/show/portfolioData/reviews/show/ReviewContext.tsx": 48,
	"./platform/portfolios/show/portfolioData/reviews/show/StageIndicator": 909,
	"./platform/portfolios/show/portfolioData/reviews/show/StageIndicator.tsx": 909,
	"./platform/portfolios/show/portfolioData/reviews/show/Tables": 889,
	"./platform/portfolios/show/portfolioData/reviews/show/Tables.tsx": 889,
	"./platform/portfolios/show/portfolioData/reviews/show/Warnings": 901,
	"./platform/portfolios/show/portfolioData/reviews/show/Warnings.tsx": 901,
	"./platform/portfolios/show/portfolioData/reviews/show/actionPoints/Card": 880,
	"./platform/portfolios/show/portfolioData/reviews/show/actionPoints/Card.tsx": 880,
	"./platform/portfolios/show/portfolioData/reviews/show/actionPoints/Info": 881,
	"./platform/portfolios/show/portfolioData/reviews/show/actionPoints/Info.tsx": 881,
	"./platform/portfolios/show/portfolioData/reviews/show/answers/AnswerDisplay": 883,
	"./platform/portfolios/show/portfolioData/reviews/show/answers/AnswerDisplay.tsx": 883,
	"./platform/portfolios/show/portfolioData/reviews/show/comments/Comment": 241,
	"./platform/portfolios/show/portfolioData/reviews/show/comments/Comment.tsx": 241,
	"./platform/portfolios/show/portfolioData/reviews/show/comments/Form": 393,
	"./platform/portfolios/show/portfolioData/reviews/show/comments/Form.tsx": 393,
	"./platform/portfolios/show/portfolioData/reviews/show/comments/Presenter": 886,
	"./platform/portfolios/show/portfolioData/reviews/show/comments/Presenter.tsx": 886,
	"./platform/portfolios/show/portfolioData/reviews/show/history/Presenter": 899,
	"./platform/portfolios/show/portfolioData/reviews/show/history/Presenter.tsx": 899,
	"./platform/portfolios/show/portfolioData/reviews/show/info/StatusButton": 512,
	"./platform/portfolios/show/portfolioData/reviews/show/info/StatusButton.tsx": 512,
	"./platform/portfolios/show/portfolioData/reviews/show/overview/PortfolioReviewStatuses": 905,
	"./platform/portfolios/show/portfolioData/reviews/show/overview/PortfolioReviewStatuses.tsx": 905,
	"./platform/portfolios/show/portfolioData/reviews/show/rating/Edit": 904,
	"./platform/portfolios/show/portfolioData/reviews/show/rating/Edit.tsx": 904,
	"./platform/portfolios/show/portfolioData/reviews/show/reports/AssignTemplates": 907,
	"./platform/portfolios/show/portfolioData/reviews/show/reports/AssignTemplates.tsx": 907,
	"./platform/portfolios/show/portfolioData/reviews/show/shared/Regenerate": 267,
	"./platform/portfolios/show/portfolioData/reviews/show/shared/Regenerate.tsx": 267,
	"./platform/portfolios/show/portfolioData/reviews/show/statuses/ApprovalComment": 1727,
	"./platform/portfolios/show/portfolioData/reviews/show/statuses/ApprovalComment.tsx": 1727,
	"./platform/portfolios/show/portfolioData/reviews/show/statuses/Back": 910,
	"./platform/portfolios/show/portfolioData/reviews/show/statuses/Back.tsx": 910,
	"./platform/portfolios/show/portfolioData/reviews/show/statuses/ImportData": 513,
	"./platform/portfolios/show/portfolioData/reviews/show/statuses/ImportData.tsx": 513,
	"./platform/portfolios/show/portfolioData/reviews/show/statuses/OnHold": 911,
	"./platform/portfolios/show/portfolioData/reviews/show/statuses/OnHold.tsx": 911,
	"./platform/portfolios/show/portfolioData/reviews/show/statuses/Send": 912,
	"./platform/portfolios/show/portfolioData/reviews/show/statuses/Send.tsx": 912,
	"./platform/portfolios/show/portfolioData/reviews/show/statuses/SubmitReview": 913,
	"./platform/portfolios/show/portfolioData/reviews/show/statuses/SubmitReview.tsx": 913,
	"./platform/portfolios/show/portfolioData/reviews/show/statuses/Terminated": 914,
	"./platform/portfolios/show/portfolioData/reviews/show/statuses/Terminated.tsx": 914,
	"./platform/portfolios/show/portfolioData/reviews/show/statuses/VerifyReview": 915,
	"./platform/portfolios/show/portfolioData/reviews/show/statuses/VerifyReview.tsx": 915,
	"./platform/portfolios/show/portfolioData/reviews/show/tables/ReturnsTable": 890,
	"./platform/portfolios/show/portfolioData/reviews/show/tables/ReturnsTable.tsx": 890,
	"./platform/portfolios/show/portfolioData/reviews/show/tables/RiskTable": 892,
	"./platform/portfolios/show/portfolioData/reviews/show/tables/RiskTable.tsx": 892,
	"./platform/portfolios/show/portfolioData/reviews/show/tables/StatisticsTable": 894,
	"./platform/portfolios/show/portfolioData/reviews/show/tables/StatisticsTable.tsx": 894,
	"./platform/portfolios/show/portfolioData/reviews/show/tables/columns/returnColumns": 891,
	"./platform/portfolios/show/portfolioData/reviews/show/tables/columns/returnColumns.tsx": 891,
	"./platform/portfolios/show/portfolioData/reviews/show/tables/columns/riskColumns": 893,
	"./platform/portfolios/show/portfolioData/reviews/show/tables/columns/riskColumns.tsx": 893,
	"./platform/portfolios/show/portfolioData/reviews/show/tables/columns/statisticsColumns": 895,
	"./platform/portfolios/show/portfolioData/reviews/show/tables/columns/statisticsColumns.tsx": 895,
	"./platform/portfolios/table/columns": 288,
	"./platform/portfolios/table/columns.tsx": 288,
	"./platform/portfolios/valuations/Table": 1728,
	"./platform/portfolios/valuations/Table.tsx": 1728,
	"./platform/portfolios/valuations/Upload": 1729,
	"./platform/portfolios/valuations/Upload.tsx": 1729,
	"./platform/portfolios/valuations/table/Destroy": 922,
	"./platform/portfolios/valuations/table/Destroy.tsx": 922,
	"./platform/portfolios/valuations/table/Edit": 923,
	"./platform/portfolios/valuations/table/Edit.tsx": 923,
	"./platform/portfolios/valuations/table/columns": 921,
	"./platform/portfolios/valuations/table/columns.tsx": 921,
	"./platform/portfolios/valuations/upload/Presenter": 924,
	"./platform/portfolios/valuations/upload/Presenter.tsx": 924,
	"./platform/relationshipManagers/Dashboard": 1730,
	"./platform/relationshipManagers/Dashboard.tsx": 1730,
	"./platform/relationshipManagers/dashboard/ClientSelect": 926,
	"./platform/relationshipManagers/dashboard/ClientSelect.tsx": 926,
	"./platform/relationshipManagers/dashboard/JurisdictionSelect": 927,
	"./platform/relationshipManagers/dashboard/JurisdictionSelect.tsx": 927,
	"./platform/relationshipManagers/dashboard/ManagerSelect": 928,
	"./platform/relationshipManagers/dashboard/ManagerSelect.tsx": 928,
	"./platform/relationshipManagers/dashboard/ReviewFilters": 925,
	"./platform/relationshipManagers/dashboard/ReviewFilters.tsx": 925,
	"./platform/relationshipManagers/dashboard/shared/Dropdown": 929,
	"./platform/relationshipManagers/dashboard/shared/Dropdown.tsx": 929,
	"./platform/relationshipManagers/dashboard/shared/DropdownOption": 930,
	"./platform/relationshipManagers/dashboard/shared/DropdownOption.tsx": 930,
	"./platform/reportDesigns/Index": 1731,
	"./platform/reportDesigns/Index.tsx": 1731,
	"./platform/reportDesigns/shared/Context": 931,
	"./platform/reportDesigns/shared/Context.tsx": 931,
	"./platform/reportTemplateBuckets/Form": 388,
	"./platform/reportTemplateBuckets/Form.tsx": 388,
	"./platform/reportTemplateBuckets/Presenter": 647,
	"./platform/reportTemplateBuckets/Presenter.tsx": 647,
	"./platform/reportTemplateBuckets/ReportTemplateBucket": 648,
	"./platform/reportTemplateBuckets/ReportTemplateBucket.tsx": 648,
	"./platform/reportTemplates": 1732,
	"./platform/reportTemplates.tsx": 1732,
	"./platform/reportTemplates/Destroy": 1733,
	"./platform/reportTemplates/Destroy.tsx": 1733,
	"./platform/reportTemplates/Duplicate": 1734,
	"./platform/reportTemplates/Duplicate.tsx": 1734,
	"./platform/reportTemplates/Filters": 933,
	"./platform/reportTemplates/Filters.tsx": 933,
	"./platform/reportTemplates/New": 934,
	"./platform/reportTemplates/New.tsx": 934,
	"./platform/reportTemplates/Presenter": 932,
	"./platform/reportTemplates/Presenter.tsx": 932,
	"./platform/reportTemplates/ReportTemplate": 935,
	"./platform/reportTemplates/ReportTemplate.tsx": 935,
	"./platform/reportTemplates/Template": 1735,
	"./platform/reportTemplates/Template.tsx": 1735,
	"./platform/reportTemplates/portfolios/Table": 1750,
	"./platform/reportTemplates/portfolios/Table.tsx": 1750,
	"./platform/reportTemplates/template/Context": 32,
	"./platform/reportTemplates/template/Context.tsx": 32,
	"./platform/reportTemplates/template/General": 937,
	"./platform/reportTemplates/template/General.tsx": 937,
	"./platform/reportTemplates/template/Presenter": 936,
	"./platform/reportTemplates/template/Presenter.tsx": 936,
	"./platform/reportTemplates/template/Report": 938,
	"./platform/reportTemplates/template/Report.tsx": 938,
	"./platform/reportTemplates/template/Sections": 1046,
	"./platform/reportTemplates/template/Sections.tsx": 1046,
	"./platform/reportTemplates/template/Theme": 1047,
	"./platform/reportTemplates/template/Theme.tsx": 1047,
	"./platform/reportTemplates/template/pages/AdditionalPages": 939,
	"./platform/reportTemplates/template/pages/AdditionalPages.tsx": 939,
	"./platform/reportTemplates/template/pages/ColorSelect": 292,
	"./platform/reportTemplates/template/pages/ColorSelect.tsx": 292,
	"./platform/reportTemplates/template/pages/CoverPage": 1031,
	"./platform/reportTemplates/template/pages/CoverPage.tsx": 1031,
	"./platform/reportTemplates/template/pages/additionalPages/Header": 940,
	"./platform/reportTemplates/template/pages/additionalPages/Header.tsx": 940,
	"./platform/reportTemplates/template/pages/coverPage/headers/landscape/ConsultingHeader": 1041,
	"./platform/reportTemplates/template/pages/coverPage/headers/landscape/ConsultingHeader.tsx": 1041,
	"./platform/reportTemplates/template/pages/coverPage/headers/landscape/CustomHeader": 435,
	"./platform/reportTemplates/template/pages/coverPage/headers/landscape/CustomHeader.tsx": 435,
	"./platform/reportTemplates/template/pages/coverPage/headers/landscape/GroupHeader": 1042,
	"./platform/reportTemplates/template/pages/coverPage/headers/landscape/GroupHeader.tsx": 1042,
	"./platform/reportTemplates/template/pages/coverPage/headers/landscape/MonitoringHeader": 1043,
	"./platform/reportTemplates/template/pages/coverPage/headers/landscape/MonitoringHeader.tsx": 1043,
	"./platform/reportTemplates/template/pages/coverPage/headers/landscape/PortfolioHeader": 1044,
	"./platform/reportTemplates/template/pages/coverPage/headers/landscape/PortfolioHeader.tsx": 1044,
	"./platform/reportTemplates/template/pages/coverPage/headers/portrait/ConsultingHeader": 1032,
	"./platform/reportTemplates/template/pages/coverPage/headers/portrait/ConsultingHeader.tsx": 1032,
	"./platform/reportTemplates/template/pages/coverPage/headers/portrait/CustomHeader": 433,
	"./platform/reportTemplates/template/pages/coverPage/headers/portrait/CustomHeader.tsx": 433,
	"./platform/reportTemplates/template/pages/coverPage/headers/portrait/GroupHeader": 1033,
	"./platform/reportTemplates/template/pages/coverPage/headers/portrait/GroupHeader.tsx": 1033,
	"./platform/reportTemplates/template/pages/coverPage/headers/portrait/MonitoringHeader": 1034,
	"./platform/reportTemplates/template/pages/coverPage/headers/portrait/MonitoringHeader.tsx": 1034,
	"./platform/reportTemplates/template/pages/coverPage/headers/portrait/PortfolioHeader": 1035,
	"./platform/reportTemplates/template/pages/coverPage/headers/portrait/PortfolioHeader.tsx": 1035,
	"./platform/reportTemplates/template/pages/footers/ConsultingFooter": 410,
	"./platform/reportTemplates/template/pages/footers/ConsultingFooter.tsx": 410,
	"./platform/reportTemplates/template/pages/footers/CustomFooter": 411,
	"./platform/reportTemplates/template/pages/footers/CustomFooter.tsx": 411,
	"./platform/reportTemplates/template/pages/footers/GroupFooter": 412,
	"./platform/reportTemplates/template/pages/footers/GroupFooter.tsx": 412,
	"./platform/reportTemplates/template/pages/footers/MonitoringFooter": 413,
	"./platform/reportTemplates/template/pages/footers/MonitoringFooter.tsx": 413,
	"./platform/reportTemplates/template/pages/footers/PortfolioFooter": 414,
	"./platform/reportTemplates/template/pages/footers/PortfolioFooter.tsx": 414,
	"./platform/reportTemplates/template/pages/landscape/AdditionalPages": 1037,
	"./platform/reportTemplates/template/pages/landscape/AdditionalPages.tsx": 1037,
	"./platform/reportTemplates/template/pages/landscape/AdditionalPagesWrapper": 1036,
	"./platform/reportTemplates/template/pages/landscape/AdditionalPagesWrapper.tsx": 1036,
	"./platform/reportTemplates/template/pages/landscape/BackPage": 1045,
	"./platform/reportTemplates/template/pages/landscape/BackPage.tsx": 1045,
	"./platform/reportTemplates/template/pages/landscape/CoverPage": 1040,
	"./platform/reportTemplates/template/pages/landscape/CoverPage.tsx": 1040,
	"./platform/reportTemplates/template/pages/landscape/CustomFooter": 1038,
	"./platform/reportTemplates/template/pages/landscape/CustomFooter.tsx": 1038,
	"./platform/reportTemplates/template/pages/landscape/Footer": 434,
	"./platform/reportTemplates/template/pages/landscape/Footer.tsx": 434,
	"./platform/reportTemplates/template/pages/landscape/RepeatingPages": 1039,
	"./platform/reportTemplates/template/pages/landscape/RepeatingPages.tsx": 1039,
	"./platform/reportTemplates/template/report/EmptySection": 942,
	"./platform/reportTemplates/template/report/EmptySection.tsx": 942,
	"./platform/reportTemplates/template/report/Row": 941,
	"./platform/reportTemplates/template/report/Row.tsx": 941,
	"./platform/reportTemplates/template/report/Rows": 242,
	"./platform/reportTemplates/template/report/Rows.tsx": 242,
	"./platform/reportTemplates/template/report/Section": 943,
	"./platform/reportTemplates/template/report/Section.tsx": 943,
	"./platform/reportTemplates/template/report/row/Edit": 1030,
	"./platform/reportTemplates/template/report/row/Edit.tsx": 1030,
	"./platform/reportTemplates/template/report/section/Edit": 944,
	"./platform/reportTemplates/template/report/section/Edit.tsx": 944,
	"./platform/reportTemplates/template/report/section/sectionEdit": 945,
	"./platform/reportTemplates/template/report/section/sectionEdit.tsx": 945,
	"./platform/reportTemplates/template/report/section/sectionEdit/BarChart": 946,
	"./platform/reportTemplates/template/report/section/sectionEdit/BarChart.tsx": 946,
	"./platform/reportTemplates/template/report/section/sectionEdit/BetaComparison": 947,
	"./platform/reportTemplates/template/report/section/sectionEdit/BetaComparison.tsx": 947,
	"./platform/reportTemplates/template/report/section/sectionEdit/Blank": 948,
	"./platform/reportTemplates/template/report/section/sectionEdit/Blank.tsx": 948,
	"./platform/reportTemplates/template/report/section/sectionEdit/ComponentSelect": 973,
	"./platform/reportTemplates/template/report/section/sectionEdit/ComponentSelect.tsx": 973,
	"./platform/reportTemplates/template/report/section/sectionEdit/Contents": 949,
	"./platform/reportTemplates/template/report/section/sectionEdit/Contents.tsx": 949,
	"./platform/reportTemplates/template/report/section/sectionEdit/CorrelationMatrix": 950,
	"./platform/reportTemplates/template/report/section/sectionEdit/CorrelationMatrix.tsx": 950,
	"./platform/reportTemplates/template/report/section/sectionEdit/DataTable": 951,
	"./platform/reportTemplates/template/report/section/sectionEdit/DataTable.tsx": 951,
	"./platform/reportTemplates/template/report/section/sectionEdit/Divider": 954,
	"./platform/reportTemplates/template/report/section/sectionEdit/Divider.tsx": 954,
	"./platform/reportTemplates/template/report/section/sectionEdit/ExtraSettings": 955,
	"./platform/reportTemplates/template/report/section/sectionEdit/ExtraSettings.tsx": 955,
	"./platform/reportTemplates/template/report/section/sectionEdit/HorizontalBarChart": 956,
	"./platform/reportTemplates/template/report/section/sectionEdit/HorizontalBarChart.tsx": 956,
	"./platform/reportTemplates/template/report/section/sectionEdit/LineChart": 957,
	"./platform/reportTemplates/template/report/section/sectionEdit/LineChart.tsx": 957,
	"./platform/reportTemplates/template/report/section/sectionEdit/List": 958,
	"./platform/reportTemplates/template/report/section/sectionEdit/List.tsx": 958,
	"./platform/reportTemplates/template/report/section/sectionEdit/MapVisual": 959,
	"./platform/reportTemplates/template/report/section/sectionEdit/MapVisual.tsx": 959,
	"./platform/reportTemplates/template/report/section/sectionEdit/MultiLayerPieChart": 960,
	"./platform/reportTemplates/template/report/section/sectionEdit/MultiLayerPieChart.tsx": 960,
	"./platform/reportTemplates/template/report/section/sectionEdit/PieChart": 961,
	"./platform/reportTemplates/template/report/section/sectionEdit/PieChart.tsx": 961,
	"./platform/reportTemplates/template/report/section/sectionEdit/PortfolioInformation": 962,
	"./platform/reportTemplates/template/report/section/sectionEdit/PortfolioInformation.tsx": 962,
	"./platform/reportTemplates/template/report/section/sectionEdit/Quote": 963,
	"./platform/reportTemplates/template/report/section/sectionEdit/Quote.tsx": 963,
	"./platform/reportTemplates/template/report/section/sectionEdit/Rating": 964,
	"./platform/reportTemplates/template/report/section/sectionEdit/Rating.tsx": 964,
	"./platform/reportTemplates/template/report/section/sectionEdit/RatingOverTime": 965,
	"./platform/reportTemplates/template/report/section/sectionEdit/RatingOverTime.tsx": 965,
	"./platform/reportTemplates/template/report/section/sectionEdit/ReviewComments": 966,
	"./platform/reportTemplates/template/report/section/sectionEdit/ReviewComments.tsx": 966,
	"./platform/reportTemplates/template/report/section/sectionEdit/ScatterChart": 967,
	"./platform/reportTemplates/template/report/section/sectionEdit/ScatterChart.tsx": 967,
	"./platform/reportTemplates/template/report/section/sectionEdit/StackedAreaChart": 970,
	"./platform/reportTemplates/template/report/section/sectionEdit/StackedAreaChart.tsx": 970,
	"./platform/reportTemplates/template/report/section/sectionEdit/Subheading": 968,
	"./platform/reportTemplates/template/report/section/sectionEdit/Subheading.tsx": 968,
	"./platform/reportTemplates/template/report/section/sectionEdit/Subtitle": 1751,
	"./platform/reportTemplates/template/report/section/sectionEdit/Subtitle.tsx": 1751,
	"./platform/reportTemplates/template/report/section/sectionEdit/SubtitleSection": 969,
	"./platform/reportTemplates/template/report/section/sectionEdit/SubtitleSection.tsx": 969,
	"./platform/reportTemplates/template/report/section/sectionEdit/TextMedium": 971,
	"./platform/reportTemplates/template/report/section/sectionEdit/TextMedium.tsx": 971,
	"./platform/reportTemplates/template/report/section/sectionEdit/TextSmall": 972,
	"./platform/reportTemplates/template/report/section/sectionEdit/TextSmall.tsx": 972,
	"./platform/reportTemplates/template/report/section/sectionEdit/Title": 514,
	"./platform/reportTemplates/template/report/section/sectionEdit/Title.tsx": 514,
	"./platform/reportTemplates/template/report/section/sectionEdit/dataTable/columnOptions": 953,
	"./platform/reportTemplates/template/report/section/sectionEdit/dataTable/columnOptions.tsx": 953,
	"./platform/reportTemplates/template/report/section/sectionEdit/rowOptions": 452,
	"./platform/reportTemplates/template/report/section/sectionEdit/rowOptions.tsx": 452,
	"./platform/reportTemplates/template/report/section/sectionEdit/shared/LegendKeys": 203,
	"./platform/reportTemplates/template/report/section/sectionEdit/shared/LegendKeys.tsx": 203,
	"./platform/reportTemplates/template/report/section/sectionEdit/shared/options": 426,
	"./platform/reportTemplates/template/report/section/sectionEdit/shared/options.tsx": 426,
	"./platform/reportTemplates/template/report/section/sectionEdit/useSectionSize": 427,
	"./platform/reportTemplates/template/report/section/sectionEdit/useSectionSize.tsx": 427,
	"./platform/reportTemplates/template/sectionDisplay": 293,
	"./platform/reportTemplates/template/sectionDisplay.tsx": 293,
	"./platform/reportTemplates/template/sectionTypes/ActionPoints": 307,
	"./platform/reportTemplates/template/sectionTypes/ActionPoints.tsx": 307,
	"./platform/reportTemplates/template/sectionTypes/BarChart": 974,
	"./platform/reportTemplates/template/sectionTypes/BarChart.tsx": 974,
	"./platform/reportTemplates/template/sectionTypes/BarChartData": 975,
	"./platform/reportTemplates/template/sectionTypes/BarChartData.tsx": 975,
	"./platform/reportTemplates/template/sectionTypes/BetaComparison": 976,
	"./platform/reportTemplates/template/sectionTypes/BetaComparison.tsx": 976,
	"./platform/reportTemplates/template/sectionTypes/BlankComponent": 977,
	"./platform/reportTemplates/template/sectionTypes/BlankComponent.tsx": 977,
	"./platform/reportTemplates/template/sectionTypes/BlankPageFiller": 978,
	"./platform/reportTemplates/template/sectionTypes/BlankPageFiller.tsx": 978,
	"./platform/reportTemplates/template/sectionTypes/ComponentSection": 979,
	"./platform/reportTemplates/template/sectionTypes/ComponentSection.tsx": 979,
	"./platform/reportTemplates/template/sectionTypes/Content": 980,
	"./platform/reportTemplates/template/sectionTypes/Content.tsx": 980,
	"./platform/reportTemplates/template/sectionTypes/CorrelationMatrix": 981,
	"./platform/reportTemplates/template/sectionTypes/CorrelationMatrix.tsx": 981,
	"./platform/reportTemplates/template/sectionTypes/CustomComponents": 223,
	"./platform/reportTemplates/template/sectionTypes/CustomComponents.tsx": 223,
	"./platform/reportTemplates/template/sectionTypes/DataTable": 982,
	"./platform/reportTemplates/template/sectionTypes/DataTable.tsx": 982,
	"./platform/reportTemplates/template/sectionTypes/Divider": 985,
	"./platform/reportTemplates/template/sectionTypes/Divider.tsx": 985,
	"./platform/reportTemplates/template/sectionTypes/DrawdownData": 992,
	"./platform/reportTemplates/template/sectionTypes/DrawdownData.tsx": 992,
	"./platform/reportTemplates/template/sectionTypes/ExtraSettings": 986,
	"./platform/reportTemplates/template/sectionTypes/ExtraSettings.tsx": 986,
	"./platform/reportTemplates/template/sectionTypes/HorizontalBarChart": 987,
	"./platform/reportTemplates/template/sectionTypes/HorizontalBarChart.tsx": 987,
	"./platform/reportTemplates/template/sectionTypes/LineChart": 989,
	"./platform/reportTemplates/template/sectionTypes/LineChart.tsx": 989,
	"./platform/reportTemplates/template/sectionTypes/LineChartData": 991,
	"./platform/reportTemplates/template/sectionTypes/LineChartData.tsx": 991,
	"./platform/reportTemplates/template/sectionTypes/List": 993,
	"./platform/reportTemplates/template/sectionTypes/List.tsx": 993,
	"./platform/reportTemplates/template/sectionTypes/LongformCommentary": 994,
	"./platform/reportTemplates/template/sectionTypes/LongformCommentary.tsx": 994,
	"./platform/reportTemplates/template/sectionTypes/MandateFlags": 1029,
	"./platform/reportTemplates/template/sectionTypes/MandateFlags.tsx": 1029,
	"./platform/reportTemplates/template/sectionTypes/MapVisual": 995,
	"./platform/reportTemplates/template/sectionTypes/MapVisual.tsx": 995,
	"./platform/reportTemplates/template/sectionTypes/MarketCommentary": 1001,
	"./platform/reportTemplates/template/sectionTypes/MarketCommentary.tsx": 1001,
	"./platform/reportTemplates/template/sectionTypes/MultiLayerPieChart": 1002,
	"./platform/reportTemplates/template/sectionTypes/MultiLayerPieChart.tsx": 1002,
	"./platform/reportTemplates/template/sectionTypes/PieChart": 1003,
	"./platform/reportTemplates/template/sectionTypes/PieChart.tsx": 1003,
	"./platform/reportTemplates/template/sectionTypes/PortfolioInformation": 1004,
	"./platform/reportTemplates/template/sectionTypes/PortfolioInformation.tsx": 1004,
	"./platform/reportTemplates/template/sectionTypes/QuestionAnswers": 1028,
	"./platform/reportTemplates/template/sectionTypes/QuestionAnswers.tsx": 1028,
	"./platform/reportTemplates/template/sectionTypes/Quote": 1007,
	"./platform/reportTemplates/template/sectionTypes/Quote.tsx": 1007,
	"./platform/reportTemplates/template/sectionTypes/Rating": 1009,
	"./platform/reportTemplates/template/sectionTypes/Rating.tsx": 1009,
	"./platform/reportTemplates/template/sectionTypes/RatingBox": 1012,
	"./platform/reportTemplates/template/sectionTypes/RatingBox.tsx": 1012,
	"./platform/reportTemplates/template/sectionTypes/RatingInfo": 1013,
	"./platform/reportTemplates/template/sectionTypes/RatingInfo.tsx": 1013,
	"./platform/reportTemplates/template/sectionTypes/RatingOverTime": 1014,
	"./platform/reportTemplates/template/sectionTypes/RatingOverTime.tsx": 1014,
	"./platform/reportTemplates/template/sectionTypes/RelationshipManager": 1015,
	"./platform/reportTemplates/template/sectionTypes/RelationshipManager.tsx": 1015,
	"./platform/reportTemplates/template/sectionTypes/Repeating": 1016,
	"./platform/reportTemplates/template/sectionTypes/Repeating.tsx": 1016,
	"./platform/reportTemplates/template/sectionTypes/ReviewComments": 1017,
	"./platform/reportTemplates/template/sectionTypes/ReviewComments.tsx": 1017,
	"./platform/reportTemplates/template/sectionTypes/ScatterChart": 1019,
	"./platform/reportTemplates/template/sectionTypes/ScatterChart.tsx": 1019,
	"./platform/reportTemplates/template/sectionTypes/ScatterChartData": 213,
	"./platform/reportTemplates/template/sectionTypes/ScatterChartData.tsx": 213,
	"./platform/reportTemplates/template/sectionTypes/ShadedLineChart": 990,
	"./platform/reportTemplates/template/sectionTypes/ShadedLineChart.tsx": 990,
	"./platform/reportTemplates/template/sectionTypes/StackedAreaChart": 1020,
	"./platform/reportTemplates/template/sectionTypes/StackedAreaChart.tsx": 1020,
	"./platform/reportTemplates/template/sectionTypes/StackedAreaChartData": 1021,
	"./platform/reportTemplates/template/sectionTypes/StackedAreaChartData.tsx": 1021,
	"./platform/reportTemplates/template/sectionTypes/Subheading": 1022,
	"./platform/reportTemplates/template/sectionTypes/Subheading.tsx": 1022,
	"./platform/reportTemplates/template/sectionTypes/Subtitle": 1023,
	"./platform/reportTemplates/template/sectionTypes/Subtitle.tsx": 1023,
	"./platform/reportTemplates/template/sectionTypes/TextMedium": 1024,
	"./platform/reportTemplates/template/sectionTypes/TextMedium.tsx": 1024,
	"./platform/reportTemplates/template/sectionTypes/TextSmall": 1025,
	"./platform/reportTemplates/template/sectionTypes/TextSmall.tsx": 1025,
	"./platform/reportTemplates/template/sectionTypes/ThemePage": 1026,
	"./platform/reportTemplates/template/sectionTypes/ThemePage.tsx": 1026,
	"./platform/reportTemplates/template/sectionTypes/Title": 1027,
	"./platform/reportTemplates/template/sectionTypes/Title.tsx": 1027,
	"./platform/reportTemplates/template/sectionTypes/chartColors": 144,
	"./platform/reportTemplates/template/sectionTypes/chartColors.tsx": 144,
	"./platform/reportTemplates/template/sectionTypes/dataTable/AssetMovements": 415,
	"./platform/reportTemplates/template/sectionTypes/dataTable/AssetMovements.tsx": 415,
	"./platform/reportTemplates/template/sectionTypes/dataTable/Beta": 416,
	"./platform/reportTemplates/template/sectionTypes/dataTable/Beta.tsx": 416,
	"./platform/reportTemplates/template/sectionTypes/dataTable/CaptureRatioTable": 425,
	"./platform/reportTemplates/template/sectionTypes/dataTable/CaptureRatioTable.tsx": 425,
	"./platform/reportTemplates/template/sectionTypes/dataTable/Comparison": 417,
	"./platform/reportTemplates/template/sectionTypes/dataTable/Comparison.tsx": 417,
	"./platform/reportTemplates/template/sectionTypes/dataTable/ConsolidatedPortfolio": 418,
	"./platform/reportTemplates/template/sectionTypes/dataTable/ConsolidatedPortfolio.tsx": 418,
	"./platform/reportTemplates/template/sectionTypes/dataTable/ConsolidatedSharpeRatio": 423,
	"./platform/reportTemplates/template/sectionTypes/dataTable/ConsolidatedSharpeRatio.tsx": 423,
	"./platform/reportTemplates/template/sectionTypes/dataTable/ConsolidatedSortinoRatio": 424,
	"./platform/reportTemplates/template/sectionTypes/dataTable/ConsolidatedSortinoRatio.tsx": 424,
	"./platform/reportTemplates/template/sectionTypes/dataTable/ConstituentMandates": 419,
	"./platform/reportTemplates/template/sectionTypes/dataTable/ConstituentMandates.tsx": 419,
	"./platform/reportTemplates/template/sectionTypes/dataTable/ConstituentTable": 983,
	"./platform/reportTemplates/template/sectionTypes/dataTable/ConstituentTable.tsx": 983,
	"./platform/reportTemplates/template/sectionTypes/dataTable/ConstituentValues": 420,
	"./platform/reportTemplates/template/sectionTypes/dataTable/ConstituentValues.tsx": 420,
	"./platform/reportTemplates/template/sectionTypes/dataTable/ExcludeRatingConstituentTable": 952,
	"./platform/reportTemplates/template/sectionTypes/dataTable/ExcludeRatingConstituentTable.tsx": 952,
	"./platform/reportTemplates/template/sectionTypes/dataTable/GenericPortfolioTable": 306,
	"./platform/reportTemplates/template/sectionTypes/dataTable/GenericPortfolioTable.tsx": 306,
	"./platform/reportTemplates/template/sectionTypes/dataTable/MandatePositioning": 421,
	"./platform/reportTemplates/template/sectionTypes/dataTable/MandatePositioning.tsx": 421,
	"./platform/reportTemplates/template/sectionTypes/dataTable/SharpeRatio": 422,
	"./platform/reportTemplates/template/sectionTypes/dataTable/SharpeRatio.tsx": 422,
	"./platform/reportTemplates/template/sectionTypes/dataTable/SortinoRatio": 984,
	"./platform/reportTemplates/template/sectionTypes/dataTable/SortinoRatio.tsx": 984,
	"./platform/reportTemplates/template/sectionTypes/portfolioInformation/Consolidated": 1006,
	"./platform/reportTemplates/template/sectionTypes/portfolioInformation/Consolidated.tsx": 1006,
	"./platform/reportTemplates/template/sectionTypes/portfolioInformation/Manager": 1005,
	"./platform/reportTemplates/template/sectionTypes/portfolioInformation/Manager.tsx": 1005,
	"./platform/reportTemplates/template/sectionTypes/portfolioInformation/Mandate": 516,
	"./platform/reportTemplates/template/sectionTypes/portfolioInformation/Mandate.tsx": 516,
	"./platform/reportTemplates/template/sectionTypes/rating/Large": 1010,
	"./platform/reportTemplates/template/sectionTypes/rating/Large.tsx": 1010,
	"./platform/reportTemplates/template/sectionTypes/rating/Small": 1011,
	"./platform/reportTemplates/template/sectionTypes/rating/Small.tsx": 1011,
	"./platform/reportTemplates/template/sectionTypes/reviewComments/Consolidated": 1018,
	"./platform/reportTemplates/template/sectionTypes/reviewComments/Consolidated.tsx": 1018,
	"./platform/reportTemplates/template/theme/ColorPicker": 102,
	"./platform/reportTemplates/template/theme/ColorPicker.tsx": 102,
	"./platform/reportTemplates/template/theme/CustomOptions": 1048,
	"./platform/reportTemplates/template/theme/CustomOptions.tsx": 1048,
	"./platform/reportTemplates/template/theme/Header": 1049,
	"./platform/reportTemplates/template/theme/Header.tsx": 1049,
	"./platform/reportTemplates/template/theme/Uploader": 309,
	"./platform/reportTemplates/template/theme/Uploader.tsx": 309,
	"./platform/reports/AreaChart": 1752,
	"./platform/reports/AreaChart.tsx": 1752,
	"./platform/reports/BarChart": 1753,
	"./platform/reports/BarChart.tsx": 1753,
	"./platform/reports/BetaComparison": 1754,
	"./platform/reports/BetaComparison.tsx": 1754,
	"./platform/reports/Contents": 1755,
	"./platform/reports/Contents.tsx": 1755,
	"./platform/reports/DrawdownChart": 1756,
	"./platform/reports/DrawdownChart.tsx": 1756,
	"./platform/reports/HorizontalBarChart": 1757,
	"./platform/reports/HorizontalBarChart.tsx": 1757,
	"./platform/reports/LineChart": 1758,
	"./platform/reports/LineChart.tsx": 1758,
	"./platform/reports/MultiLayerPieChart": 1759,
	"./platform/reports/MultiLayerPieChart.tsx": 1759,
	"./platform/reports/PieChart": 1760,
	"./platform/reports/PieChart.tsx": 1760,
	"./platform/reports/RatingOverTime": 1761,
	"./platform/reports/RatingOverTime.tsx": 1761,
	"./platform/reports/ScatterChart": 1762,
	"./platform/reports/ScatterChart.tsx": 1762,
	"./platform/reports/ShadedLineChart": 1763,
	"./platform/reports/ShadedLineChart.tsx": 1763,
	"./platform/reports/Table": 1764,
	"./platform/reports/Table.tsx": 1764,
	"./platform/reports/chartColors": 145,
	"./platform/reports/chartColors.tsx": 145,
	"./platform/reviews/AssignModal": 163,
	"./platform/reviews/AssignModal.tsx": 163,
	"./platform/reviews/AssignOwner": 305,
	"./platform/reviews/AssignOwner.tsx": 305,
	"./platform/reviews/AssignSelection": 1765,
	"./platform/reviews/AssignSelection.tsx": 1765,
	"./platform/reviews/Index": 1766,
	"./platform/reviews/Index.tsx": 1766,
	"./platform/reviews/actionPoints/CompletionForm": 618,
	"./platform/reviews/actionPoints/CompletionForm.tsx": 618,
	"./platform/reviews/actionPoints/DeferralForm": 382,
	"./platform/reviews/actionPoints/DeferralForm.tsx": 382,
	"./platform/reviews/actionPoints/Form": 616,
	"./platform/reviews/actionPoints/Form.tsx": 616,
	"./platform/reviews/actionPoints/deferralForm/NewFields": 619,
	"./platform/reviews/actionPoints/deferralForm/NewFields.tsx": 619,
	"./platform/reviews/actionPoints/form/CommonFields": 622,
	"./platform/reviews/actionPoints/form/CommonFields.tsx": 622,
	"./platform/reviews/actionPoints/form/DeferralNotesList": 623,
	"./platform/reviews/actionPoints/form/DeferralNotesList.tsx": 623,
	"./platform/reviews/actionPoints/form/FileUpload": 265,
	"./platform/reviews/actionPoints/form/FileUpload.tsx": 265,
	"./platform/reviews/actionPoints/form/Main": 617,
	"./platform/reviews/actionPoints/form/Main.tsx": 617,
	"./platform/reviews/index/Actions": 1050,
	"./platform/reviews/index/Actions.tsx": 1050,
	"./platform/reviews/index/Confirm": 1052,
	"./platform/reviews/index/Confirm.tsx": 1052,
	"./platform/reviews/index/QueueSelect": 1054,
	"./platform/reviews/index/QueueSelect.tsx": 1054,
	"./platform/reviews/index/actions/ReviewReasonsModalContent": 1051,
	"./platform/reviews/index/actions/ReviewReasonsModalContent.tsx": 1051,
	"./platform/reviews/index/columns": 1053,
	"./platform/reviews/index/columns.tsx": 1053,
	"./platform/reviews/index/useReviewTransitionReasons": 409,
	"./platform/reviews/index/useReviewTransitionReasons.tsx": 409,
	"./platform/search/InclusionDropdown": 650,
	"./platform/search/InclusionDropdown.tsx": 650,
	"./platform/search/Presenter": 649,
	"./platform/search/Presenter.tsx": 649,
	"./platform/searches/Table": 1767,
	"./platform/searches/Table.tsx": 1767,
	"./platform/searches/table/columns": 1055,
	"./platform/searches/table/columns.tsx": 1055,
	"./platform/securities/Form": 1768,
	"./platform/securities/Form.tsx": 1768,
	"./platform/securities/Table": 1769,
	"./platform/securities/Table.tsx": 1769,
	"./platform/securities/form/Context": 436,
	"./platform/securities/form/Context.tsx": 436,
	"./platform/securities/form/SecurityClassificationsForm": 1057,
	"./platform/securities/form/SecurityClassificationsForm.tsx": 1057,
	"./platform/securities/form/SecurityInformation": 1056,
	"./platform/securities/form/SecurityInformation.tsx": 1056,
	"./platform/securities/form/securityClassificationsForm/ClassificationEdit": 1059,
	"./platform/securities/form/securityClassificationsForm/ClassificationEdit.tsx": 1059,
	"./platform/securities/form/securityClassificationsForm/Confirm": 517,
	"./platform/securities/form/securityClassificationsForm/Confirm.tsx": 517,
	"./platform/securities/form/securityClassificationsForm/ReferenceDateSelector": 1058,
	"./platform/securities/form/securityClassificationsForm/ReferenceDateSelector.tsx": 1058,
	"./platform/securities/form/securityClassificationsForm/Upload": 1770,
	"./platform/securities/form/securityClassificationsForm/Upload.tsx": 1770,
	"./platform/securities/form/securityClassificationsForm/UploadsTable": 1771,
	"./platform/securities/form/securityClassificationsForm/UploadsTable.tsx": 1771,
	"./platform/securities/form/securityClassificationsForm/classificationEdit/ClassificationWeightingsSection": 1061,
	"./platform/securities/form/securityClassificationsForm/classificationEdit/ClassificationWeightingsSection.tsx": 1061,
	"./platform/securities/form/securityClassificationsForm/classificationEdit/DraftClassificationOptions": 1060,
	"./platform/securities/form/securityClassificationsForm/classificationEdit/DraftClassificationOptions.tsx": 1060,
	"./platform/securities/form/securityClassificationsForm/classificationEdit/classificationValuesSections/ClassificationSection": 1062,
	"./platform/securities/form/securityClassificationsForm/classificationEdit/classificationValuesSections/ClassificationSection.tsx": 1062,
	"./platform/securities/form/securityClassificationsForm/classificationEdit/classificationValuesSections/classificationSection/ClassificationSelect": 1063,
	"./platform/securities/form/securityClassificationsForm/classificationEdit/classificationValuesSections/classificationSection/ClassificationSelect.tsx": 1063,
	"./platform/securities/form/securityClassificationsForm/classificationUploads/table/Destroy": 1067,
	"./platform/securities/form/securityClassificationsForm/classificationUploads/table/Destroy.tsx": 1067,
	"./platform/securities/form/securityClassificationsForm/classificationUploads/table/Edit": 1068,
	"./platform/securities/form/securityClassificationsForm/classificationUploads/table/Edit.tsx": 1068,
	"./platform/securities/form/securityClassificationsForm/classificationUploads/table/columns": 1066,
	"./platform/securities/form/securityClassificationsForm/classificationUploads/table/columns.tsx": 1066,
	"./platform/securities/form/securityClassificationsForm/classificationUploads/upload/Presenter": 1065,
	"./platform/securities/form/securityClassificationsForm/classificationUploads/upload/Presenter.tsx": 1065,
	"./platform/securities/show/ClassificationWrapper": 1772,
	"./platform/securities/show/ClassificationWrapper.tsx": 1772,
	"./platform/securities/show/classificationWrapper/ClassificationBreakdown": 1069,
	"./platform/securities/show/classificationWrapper/ClassificationBreakdown.tsx": 1069,
	"./platform/securities/table/columns": 1064,
	"./platform/securities/table/columns.tsx": 1064,
	"./platform/tableDataModifier/Presenter": 652,
	"./platform/tableDataModifier/Presenter.tsx": 652,
	"./platform/templateActionPoints/Display": 653,
	"./platform/templateActionPoints/Display.tsx": 653,
	"./platform/templateActionPoints/Form": 389,
	"./platform/templateActionPoints/Form.tsx": 389,
	"./platform/templateActionPoints/New": 654,
	"./platform/templateActionPoints/New.tsx": 654,
	"./platform/todoList/Item": 502,
	"./platform/todoList/Item.tsx": 502,
	"./platform/todoList/NewItem": 656,
	"./platform/todoList/NewItem.tsx": 656,
	"./platform/todoList/Presenter": 655,
	"./platform/todoList/Presenter.tsx": 655,
	"./platform/tracker/DataTargets": 658,
	"./platform/tracker/DataTargets.tsx": 658,
	"./platform/tracker/Presenter": 657,
	"./platform/tracker/Presenter.tsx": 657,
	"./platform/tracker/VerificationTargets": 662,
	"./platform/tracker/VerificationTargets.tsx": 662,
	"./platform/tracker/WritingTargets": 665,
	"./platform/tracker/WritingTargets.tsx": 665,
	"./platform/tracker/dataTargets/Individual": 659,
	"./platform/tracker/dataTargets/Individual.tsx": 659,
	"./platform/tracker/dataTargets/Overall": 660,
	"./platform/tracker/dataTargets/Overall.tsx": 660,
	"./platform/tracker/verificationTargets/Individual": 664,
	"./platform/tracker/verificationTargets/Individual.tsx": 664,
	"./platform/tracker/verificationTargets/Overall": 663,
	"./platform/tracker/verificationTargets/Overall.tsx": 663,
	"./platform/tracker/writingTargets/Individual": 667,
	"./platform/tracker/writingTargets/Individual.tsx": 667,
	"./platform/tracker/writingTargets/Overall": 666,
	"./platform/tracker/writingTargets/Overall.tsx": 666,
	"./platform/users/DeactivateUserButton": 1964,
	"./platform/users/DeactivateUserButton.tsx": 1964,
	"./platform/users/Portfolios": 1773,
	"./platform/users/Portfolios.tsx": 1773,
	"./platform/users/ReactivateUserButton": 1774,
	"./platform/users/ReactivateUserButton.tsx": 1774,
	"./platform/users/Table": 689,
	"./platform/users/Table.tsx": 689,
	"./platform/users/UserForm": 1775,
	"./platform/users/UserForm.tsx": 1775,
	"./platform/users/form/ClientPortalManagement": 1075,
	"./platform/users/form/ClientPortalManagement.tsx": 1075,
	"./platform/users/form/ClientRoles": 1076,
	"./platform/users/form/ClientRoles.tsx": 1076,
	"./platform/users/form/ClientSelection": 1077,
	"./platform/users/form/ClientSelection.tsx": 1077,
	"./platform/users/form/Columns": 1079,
	"./platform/users/form/Columns.tsx": 1079,
	"./platform/users/form/Form": 1072,
	"./platform/users/form/Form.tsx": 1072,
	"./platform/users/form/FormJsx": 1073,
	"./platform/users/form/FormJsx.tsx": 1073,
	"./platform/users/form/PersonalDetails": 1074,
	"./platform/users/form/PersonalDetails.tsx": 1074,
	"./platform/users/form/RoleSelection": 1078,
	"./platform/users/form/RoleSelection.tsx": 1078,
	"./platform/users/form/RoleSelector": 396,
	"./platform/users/form/RoleSelector.tsx": 396,
	"./platform/users/table/columns": 690,
	"./platform/users/table/columns.tsx": 690,
	"./portal/Downloads": 1776,
	"./portal/Downloads.tsx": 1776,
	"./portal/EnhanceBlog": 1777,
	"./portal/EnhanceBlog.tsx": 1777,
	"./portal/Notifications": 1962,
	"./portal/Notifications.tsx": 1962,
	"./portal/Resources": 1787,
	"./portal/Resources.tsx": 1787,
	"./portal/actionPoints/Show": 131,
	"./portal/actionPoints/Show.tsx": 131,
	"./portal/actionPoints/show/Information": 1084,
	"./portal/actionPoints/show/Information.tsx": 1084,
	"./portal/actionPoints/show/Notes": 1083,
	"./portal/actionPoints/show/Notes.tsx": 1083,
	"./portal/actionPoints/show/Uploader": 1082,
	"./portal/actionPoints/show/Uploader.tsx": 1082,
	"./portal/actionPoints/show/actions/ActionPointAssigner": 1088,
	"./portal/actionPoints/show/actions/ActionPointAssigner.tsx": 1088,
	"./portal/actionPoints/show/actions/Actions": 1085,
	"./portal/actionPoints/show/actions/Actions.tsx": 1085,
	"./portal/actionPoints/show/actions/inProgress/InProgressActions": 1087,
	"./portal/actionPoints/show/actions/inProgress/InProgressActions.tsx": 1087,
	"./portal/actionPoints/show/actions/inProgress/InProgressButton": 519,
	"./portal/actionPoints/show/actions/inProgress/InProgressButton.tsx": 519,
	"./portal/actionPoints/show/actions/inReview/InReviewActions": 1086,
	"./portal/actionPoints/show/actions/inReview/InReviewActions.tsx": 1086,
	"./portal/actionPoints/show/actions/inReview/InReviewButton": 518,
	"./portal/actionPoints/show/actions/inReview/InReviewButton.tsx": 518,
	"./portal/clients/Show": 1788,
	"./portal/clients/Show.tsx": 1788,
	"./portal/clients/portfolios/Show": 1795,
	"./portal/clients/portfolios/Show.tsx": 1795,
	"./portal/clients/portfolios/show/AssetAllocation": 1114,
	"./portal/clients/portfolios/show/AssetAllocation.tsx": 1114,
	"./portal/clients/portfolios/show/ClientPerformanceChart": 1118,
	"./portal/clients/portfolios/show/ClientPerformanceChart.tsx": 1118,
	"./portal/clients/portfolios/show/ComplianceTable": 1129,
	"./portal/clients/portfolios/show/ComplianceTable.tsx": 1129,
	"./portal/clients/portfolios/show/CurrencyAllocation": 1115,
	"./portal/clients/portfolios/show/CurrencyAllocation.tsx": 1115,
	"./portal/clients/portfolios/show/Drawdown": 1116,
	"./portal/clients/portfolios/show/Drawdown.tsx": 1116,
	"./portal/clients/portfolios/show/InfoBar": 1117,
	"./portal/clients/portfolios/show/InfoBar.tsx": 1117,
	"./portal/clients/portfolios/show/Mandate": 1796,
	"./portal/clients/portfolios/show/Mandate.tsx": 1796,
	"./portal/clients/portfolios/show/MandateFlags": 1797,
	"./portal/clients/portfolios/show/MandateFlags.tsx": 1797,
	"./portal/clients/portfolios/show/Metrics": 1798,
	"./portal/clients/portfolios/show/Metrics.tsx": 1798,
	"./portal/clients/portfolios/show/PortfolioInformation": 1119,
	"./portal/clients/portfolios/show/PortfolioInformation.tsx": 1119,
	"./portal/clients/portfolios/show/Presenter": 1113,
	"./portal/clients/portfolios/show/Presenter.tsx": 1113,
	"./portal/clients/portfolios/show/Rating": 1799,
	"./portal/clients/portfolios/show/Rating.tsx": 1799,
	"./portal/clients/portfolios/show/Returns": 1120,
	"./portal/clients/portfolios/show/Returns.tsx": 1120,
	"./portal/clients/portfolios/show/Reviews": 1122,
	"./portal/clients/portfolios/show/Reviews.tsx": 1122,
	"./portal/clients/portfolios/show/Risk": 1123,
	"./portal/clients/portfolios/show/Risk.tsx": 1123,
	"./portal/clients/portfolios/show/RiskReturn": 1125,
	"./portal/clients/portfolios/show/RiskReturn.tsx": 1125,
	"./portal/clients/portfolios/show/Structure": 1141,
	"./portal/clients/portfolios/show/Structure.tsx": 1141,
	"./portal/clients/portfolios/show/Value": 1126,
	"./portal/clients/portfolios/show/Value.tsx": 1126,
	"./portal/clients/portfolios/show/assetAllocation/SubChart": 1800,
	"./portal/clients/portfolios/show/assetAllocation/SubChart.tsx": 1800,
	"./portal/clients/portfolios/show/infoBar/AdditionalInfo": 1801,
	"./portal/clients/portfolios/show/infoBar/AdditionalInfo.tsx": 1801,
	"./portal/clients/portfolios/show/metrics/columns": 1130,
	"./portal/clients/portfolios/show/metrics/columns.tsx": 1130,
	"./portal/clients/portfolios/show/returns/columns": 1121,
	"./portal/clients/portfolios/show/returns/columns.tsx": 1121,
	"./portal/clients/portfolios/show/risk/columns": 1124,
	"./portal/clients/portfolios/show/risk/columns.tsx": 1124,
	"./portal/clients/portfolios/show/selectableComparisons": 441,
	"./portal/clients/portfolios/show/selectableComparisons.tsx": 441,
	"./portal/clients/portfolios/show/shared/types": 1802,
	"./portal/clients/portfolios/show/shared/types.tsx": 1802,
	"./portal/clients/portfolios/show/structure/ConsolidatedBreakdown": 1803,
	"./portal/clients/portfolios/show/structure/ConsolidatedBreakdown.tsx": 1803,
	"./portal/clients/portfolios/show/value/Chart": 1804,
	"./portal/clients/portfolios/show/value/Chart.tsx": 1804,
	"./portal/clients/portfolios/show/value/Table": 1127,
	"./portal/clients/portfolios/show/value/Table.tsx": 1127,
	"./portal/clients/portfolios/show/value/columns": 1128,
	"./portal/clients/portfolios/show/value/columns.tsx": 1128,
	"./portal/clients/show/AssetsUnderManagement": 1093,
	"./portal/clients/show/AssetsUnderManagement.tsx": 1093,
	"./portal/clients/show/ClientServiceType": 1094,
	"./portal/clients/show/ClientServiceType.tsx": 1094,
	"./portal/clients/show/EmapCparRadioToggles": 1111,
	"./portal/clients/show/EmapCparRadioToggles.tsx": 1111,
	"./portal/clients/show/Header": 1097,
	"./portal/clients/show/Header.tsx": 1097,
	"./portal/clients/show/ImBreakdown": 1099,
	"./portal/clients/show/ImBreakdown.tsx": 1099,
	"./portal/clients/show/Overview": 1805,
	"./portal/clients/show/Overview.tsx": 1805,
	"./portal/clients/show/PieChartTableLegend": 117,
	"./portal/clients/show/PieChartTableLegend.tsx": 117,
	"./portal/clients/show/Portfolios": 1104,
	"./portal/clients/show/Portfolios.tsx": 1104,
	"./portal/clients/show/Presenter": 1089,
	"./portal/clients/show/Presenter.tsx": 1089,
	"./portal/clients/show/RatingBreakdown": 1108,
	"./portal/clients/show/RatingBreakdown.tsx": 1108,
	"./portal/clients/show/RatingBreakdownBarChart": 1109,
	"./portal/clients/show/RatingBreakdownBarChart.tsx": 1109,
	"./portal/clients/show/ReviewBreakdown": 1110,
	"./portal/clients/show/ReviewBreakdown.tsx": 1110,
	"./portal/clients/show/RiskBreakdown": 1112,
	"./portal/clients/show/RiskBreakdown.tsx": 1112,
	"./portal/clients/show/clientServiceType/ClientTypeSplit": 1095,
	"./portal/clients/show/clientServiceType/ClientTypeSplit.tsx": 1095,
	"./portal/clients/show/clientServiceType/ServiceType": 1096,
	"./portal/clients/show/clientServiceType/ServiceType.tsx": 1096,
	"./portal/clients/show/header/Reorder": 1098,
	"./portal/clients/show/header/Reorder.tsx": 1098,
	"./portal/clients/show/header/Settings": 438,
	"./portal/clients/show/header/Settings.tsx": 438,
	"./portal/clients/show/imBreakdown/Chart": 1101,
	"./portal/clients/show/imBreakdown/Chart.tsx": 1101,
	"./portal/clients/show/imBreakdown/RenderData": 1100,
	"./portal/clients/show/imBreakdown/RenderData.tsx": 1100,
	"./portal/clients/show/imBreakdown/Table": 1102,
	"./portal/clients/show/imBreakdown/Table.tsx": 1102,
	"./portal/clients/show/imBreakdown/columns": 1103,
	"./portal/clients/show/imBreakdown/columns.tsx": 1103,
	"./portal/clients/show/portfolios/ContactFilter": 1107,
	"./portal/clients/show/portfolios/ContactFilter.tsx": 1107,
	"./portal/clients/show/portfolios/columns": 1106,
	"./portal/clients/show/portfolios/columns.tsx": 1106,
	"./portal/clients/show/shared/stateToggle": 177,
	"./portal/clients/show/shared/stateToggle.tsx": 177,
	"./portal/navItem": 1806,
	"./portal/navItem.tsx": 1806,
	"./portal/resources/FinancialClock": 1131,
	"./portal/resources/FinancialClock.tsx": 1131,
	"./portal/resources/FinancialClocks": 1940,
	"./portal/resources/FinancialClocks.tsx": 1940,
	"./portal/resources/ResourceCard": 1081,
	"./portal/resources/ResourceCard.tsx": 1081,
	"./portal/shared/ActionPointCard": 1091,
	"./portal/shared/ActionPointCard.tsx": 1091,
	"./portal/shared/ActionPointListItem": 1090,
	"./portal/shared/ActionPointListItem.tsx": 1090,
	"./portal/shared/ActionPointMapper": 520,
	"./portal/shared/ActionPointMapper.tsx": 520,
	"./portal/shared/ActionPointStatusFilter": 1092,
	"./portal/shared/ActionPointStatusFilter.tsx": 1092,
	"./portal/shared/ActionPoints": 437,
	"./portal/shared/ActionPoints.tsx": 437,
	"./portal/shared/ClientPortalCard": 73,
	"./portal/shared/ClientPortalCard.tsx": 73,
	"./shared/Alert": 47,
	"./shared/Alert.tsx": 47,
	"./shared/Alerter": 1080,
	"./shared/Alerter.tsx": 1080,
	"./shared/AssetAllocationSlider": 183,
	"./shared/AssetAllocationSlider/": 183,
	"./shared/AssetAllocationSlider/index": 183,
	"./shared/AssetAllocationSlider/index.tsx": 183,
	"./shared/Checkbox": 118,
	"./shared/Checkbox/": 118,
	"./shared/Checkbox/index": 118,
	"./shared/Checkbox/index.tsx": 118,
	"./shared/CriterionHumanizer": 297,
	"./shared/CriterionHumanizer.tsx": 297,
	"./shared/CsrfToken": 43,
	"./shared/CsrfToken.tsx": 43,
	"./shared/CustomModal": 30,
	"./shared/CustomModal.tsx": 30,
	"./shared/EditModel": 1941,
	"./shared/EditModel.tsx": 1941,
	"./shared/GraphitiTableWrapper": 51,
	"./shared/GraphitiTableWrapper.tsx": 51,
	"./shared/HigherOrderComponents": 161,
	"./shared/HigherOrderComponents.tsx": 161,
	"./shared/InvestmentRestrictions": 284,
	"./shared/InvestmentRestrictions/": 284,
	"./shared/InvestmentRestrictions/Flags": 246,
	"./shared/InvestmentRestrictions/Flags/": 246,
	"./shared/InvestmentRestrictions/Flags/CheckboxFlag": 342,
	"./shared/InvestmentRestrictions/Flags/CheckboxFlag.tsx": 342,
	"./shared/InvestmentRestrictions/Flags/ConfigurationSettings": 289,
	"./shared/InvestmentRestrictions/Flags/ConfigurationSettings.tsx": 289,
	"./shared/InvestmentRestrictions/Flags/FlagSelector": 704,
	"./shared/InvestmentRestrictions/Flags/FlagSelector.tsx": 704,
	"./shared/InvestmentRestrictions/Flags/FlagsSelector": 703,
	"./shared/InvestmentRestrictions/Flags/FlagsSelector.tsx": 703,
	"./shared/InvestmentRestrictions/Flags/RadioFlag": 505,
	"./shared/InvestmentRestrictions/Flags/RadioFlag.tsx": 505,
	"./shared/InvestmentRestrictions/Flags/RangeSliderFlag": 212,
	"./shared/InvestmentRestrictions/Flags/RangeSliderFlag.tsx": 212,
	"./shared/InvestmentRestrictions/Flags/SliderFlag": 251,
	"./shared/InvestmentRestrictions/Flags/SliderFlag.tsx": 251,
	"./shared/InvestmentRestrictions/Flags/index": 246,
	"./shared/InvestmentRestrictions/Flags/index.tsx": 246,
	"./shared/InvestmentRestrictions/Flags/useFlag": 166,
	"./shared/InvestmentRestrictions/Flags/useFlag.tsx": 166,
	"./shared/InvestmentRestrictions/StrategicAllocation": 701,
	"./shared/InvestmentRestrictions/StrategicAllocation.tsx": 701,
	"./shared/InvestmentRestrictions/TacticalAllocations": 702,
	"./shared/InvestmentRestrictions/TacticalAllocations.tsx": 702,
	"./shared/InvestmentRestrictions/context": 130,
	"./shared/InvestmentRestrictions/context.tsx": 130,
	"./shared/InvestmentRestrictions/index": 284,
	"./shared/InvestmentRestrictions/index.tsx": 284,
	"./shared/Loading": 15,
	"./shared/Loading.tsx": 15,
	"./shared/NoteCards": 869,
	"./shared/NoteCards.tsx": 869,
	"./shared/QuarterIndicator": 194,
	"./shared/QuarterIndicator.tsx": 194,
	"./shared/Search": 201,
	"./shared/Search.tsx": 201,
	"./shared/SelectionCounter": 785,
	"./shared/SelectionCounter.tsx": 785,
	"./shared/Slider": 372,
	"./shared/Slider/": 372,
	"./shared/Slider/index": 372,
	"./shared/Slider/index.tsx": 372,
	"./shared/TableWrapper": 1942,
	"./shared/TableWrapper.tsx": 1942,
	"./shared/Toast": 1959,
	"./shared/Toast.tsx": 1959,
	"./shared/Typography": 37,
	"./shared/Typography.tsx": 37,
	"./shared/Utils": 14,
	"./shared/Utils.tsx": 14,
	"./shared/charting/WorldMap": 996,
	"./shared/charting/WorldMap.tsx": 996,
	"./shared/charting/composed/LineChartWithModal": 290,
	"./shared/charting/composed/LineChartWithModal.tsx": 290,
	"./shared/charting/recharts/MultiLayerPieChart": 432,
	"./shared/charting/recharts/MultiLayerPieChart.tsx": 432,
	"./shared/charting/recharts/ReactAreaChart": 405,
	"./shared/charting/recharts/ReactAreaChart.tsx": 405,
	"./shared/charting/recharts/ReactAreaChartNoData": 781,
	"./shared/charting/recharts/ReactAreaChartNoData.tsx": 781,
	"./shared/charting/recharts/ReactBubbleChart": 1943,
	"./shared/charting/recharts/ReactBubbleChart.tsx": 1943,
	"./shared/charting/recharts/ReactFloatingBarChart": 294,
	"./shared/charting/recharts/ReactFloatingBarChart.tsx": 294,
	"./shared/charting/recharts/ReactHorizontalBarChart": 428,
	"./shared/charting/recharts/ReactHorizontalBarChart.tsx": 428,
	"./shared/charting/recharts/ReactLineChart": 146,
	"./shared/charting/recharts/ReactLineChart.tsx": 146,
	"./shared/charting/recharts/ReactPieChart": 79,
	"./shared/charting/recharts/ReactPieChart.tsx": 79,
	"./shared/charting/recharts/ReactScatterChart": 522,
	"./shared/charting/recharts/ReactScatterChart.tsx": 522,
	"./shared/charting/recharts/ReactStackedAreaChart": 439,
	"./shared/charting/recharts/ReactStackedAreaChart.tsx": 439,
	"./shared/charting/recharts/interfaces/IAreaChartData": 1944,
	"./shared/charting/recharts/interfaces/IAreaChartData.tsx": 1944,
	"./shared/charting/recharts/interfaces/IPieChartData": 1945,
	"./shared/charting/recharts/interfaces/IPieChartData.tsx": 1945,
	"./shared/charting/recharts/reactAreaChart/CustomTooltip": 782,
	"./shared/charting/recharts/reactAreaChart/CustomTooltip.tsx": 782,
	"./shared/charting/recharts/reactBubbleChart/Axes": 523,
	"./shared/charting/recharts/reactBubbleChart/Axes.tsx": 523,
	"./shared/charting/recharts/reactBubbleChart/CustomLegend": 1135,
	"./shared/charting/recharts/reactBubbleChart/CustomLegend.tsx": 1135,
	"./shared/charting/recharts/reactFloatingBarChart/ChartComponents": 988,
	"./shared/charting/recharts/reactFloatingBarChart/ChartComponents.tsx": 988,
	"./shared/charting/recharts/reactHorizontalBarChart/ChartComponents": 515,
	"./shared/charting/recharts/reactHorizontalBarChart/ChartComponents.tsx": 515,
	"./shared/charting/recharts/reactLineChart/CustomLegend": 1946,
	"./shared/charting/recharts/reactLineChart/CustomLegend.tsx": 1946,
	"./shared/charting/recharts/reactLineChart/CustomTooltip": 661,
	"./shared/charting/recharts/reactLineChart/CustomTooltip.tsx": 661,
	"./shared/charting/recharts/reactPieChart/EmptyChart": 612,
	"./shared/charting/recharts/reactPieChart/EmptyChart.tsx": 612,
	"./shared/charting/recharts/reactScatterChart/ChartComponents": 186,
	"./shared/charting/recharts/reactScatterChart/ChartComponents.tsx": 186,
	"./shared/charting/recharts/reactStackedAreaChart/ChartComponents": 521,
	"./shared/charting/recharts/reactStackedAreaChart/ChartComponents.tsx": 521,
	"./shared/charting/utilities/ticks": 390,
	"./shared/charting/utilities/ticks.tsx": 390,
	"./shared/charting/worldMap/Helpers": 1947,
	"./shared/charting/worldMap/Helpers.tsx": 1947,
	"./shared/charting/worldMap/topojsonWorld.json": 1736,
	"./shared/classificationFlags/FlagSelector": 694,
	"./shared/classificationFlags/FlagSelector.tsx": 694,
	"./shared/classificationFlags/FlagsSelector": 397,
	"./shared/classificationFlags/FlagsSelector.tsx": 397,
	"./shared/colours": 56,
	"./shared/colours/": 56,
	"./shared/colours/functions": 371,
	"./shared/colours/functions.tsx": 371,
	"./shared/colours/hacks/benchmarkColourGenerator": 444,
	"./shared/colours/hacks/benchmarkColourGenerator.tsx": 444,
	"./shared/colours/index": 56,
	"./shared/colours/index.tsx": 56,
	"./shared/colours/themes/clientPortal": 169,
	"./shared/colours/themes/clientPortal.tsx": 169,
	"./shared/colours/themes/default": 589,
	"./shared/colours/themes/default.tsx": 589,
	"./shared/context/CompanyContext": 383,
	"./shared/context/CompanyContext.tsx": 383,
	"./shared/context/CurrentUserContext": 91,
	"./shared/context/CurrentUserContext.tsx": 91,
	"./shared/context/ThemeContext": 113,
	"./shared/context/ThemeContext.tsx": 113,
	"./shared/customHooks/useAjaxRequest": 93,
	"./shared/customHooks/useAjaxRequest.tsx": 93,
	"./shared/customHooks/useAsyncFunctionInjector": 224,
	"./shared/customHooks/useAsyncFunctionInjector.tsx": 224,
	"./shared/customHooks/useAsyncState": 501,
	"./shared/customHooks/useAsyncState.tsx": 501,
	"./shared/customHooks/useChartFilter": 178,
	"./shared/customHooks/useChartFilter.tsx": 178,
	"./shared/customHooks/useCheckbox": 803,
	"./shared/customHooks/useCheckbox.tsx": 803,
	"./shared/customHooks/useCompare": 1134,
	"./shared/customHooks/useCompare.tsx": 1134,
	"./shared/customHooks/useComponentProxy": 1105,
	"./shared/customHooks/useComponentProxy.tsx": 1105,
	"./shared/customHooks/useDebounce": 101,
	"./shared/customHooks/useDebounce.tsx": 101,
	"./shared/customHooks/useDraggable": 733,
	"./shared/customHooks/useDraggable.tsx": 733,
	"./shared/customHooks/useEventTrigger": 1948,
	"./shared/customHooks/useEventTrigger.tsx": 1948,
	"./shared/customHooks/useForm": 628,
	"./shared/customHooks/useForm.tsx": 628,
	"./shared/customHooks/useGraphitiForm": 127,
	"./shared/customHooks/useGraphitiForm.tsx": 127,
	"./shared/customHooks/useLocalStorage": 147,
	"./shared/customHooks/useLocalStorage.tsx": 147,
	"./shared/customHooks/useRadioSelect": 114,
	"./shared/customHooks/useRadioSelect.tsx": 114,
	"./shared/customHooks/useReactSelect": 1071,
	"./shared/customHooks/useReactSelect.tsx": 1071,
	"./shared/customHooks/useRecurringRerender": 740,
	"./shared/customHooks/useRecurringRerender.tsx": 740,
	"./shared/customHooks/useRerender": 176,
	"./shared/customHooks/useRerender.tsx": 176,
	"./shared/customHooks/useSharedState": 834,
	"./shared/customHooks/useSharedState.tsx": 834,
	"./shared/customHooks/useSpraypaintQuery": 164,
	"./shared/customHooks/useSpraypaintQuery.tsx": 164,
	"./shared/customHooks/useStateSetAttr": 1070,
	"./shared/customHooks/useStateSetAttr.tsx": 1070,
	"./shared/customHooks/useThemeColours": 196,
	"./shared/customHooks/useThemeColours.tsx": 196,
	"./shared/customHooks/useVisibility": 18,
	"./shared/customHooks/useVisibility.tsx": 18,
	"./shared/dashboard/HeadlineBox": 1949,
	"./shared/dashboard/HeadlineBox.tsx": 1949,
	"./shared/editModel/Input": 402,
	"./shared/editModel/Input.tsx": 402,
	"./shared/editModel/Presenter": 1132,
	"./shared/editModel/Presenter.tsx": 1132,
	"./shared/editModel/interfaces/IAttribute": 1950,
	"./shared/editModel/interfaces/IAttribute.tsx": 1950,
	"./shared/forms/AutoResizeTextArea": 92,
	"./shared/forms/AutoResizeTextArea.tsx": 92,
	"./shared/forms/BooleanOption": 115,
	"./shared/forms/BooleanOption.tsx": 115,
	"./shared/forms/Button": 31,
	"./shared/forms/Button.tsx": 31,
	"./shared/forms/CountrySelect": 268,
	"./shared/forms/CountrySelect.tsx": 268,
	"./shared/forms/DataFrequencyPicker": 772,
	"./shared/forms/DataFrequencyPicker.tsx": 772,
	"./shared/forms/Dropzone": 61,
	"./shared/forms/Dropzone.tsx": 61,
	"./shared/forms/FormFilesDropzone": 239,
	"./shared/forms/FormFilesDropzone.tsx": 239,
	"./shared/forms/FormRow": 11,
	"./shared/forms/FormRow.tsx": 11,
	"./shared/forms/FormTag": 142,
	"./shared/forms/FormTag.tsx": 142,
	"./shared/forms/ProgressBar": 1951,
	"./shared/forms/ProgressBar.tsx": 1951,
	"./shared/forms/QuarterPicker": 126,
	"./shared/forms/QuarterPicker.tsx": 126,
	"./shared/forms/RadioButtonGroup": 400,
	"./shared/forms/RadioButtonGroup.tsx": 400,
	"./shared/forms/RangeSlider": 143,
	"./shared/forms/RangeSlider.tsx": 143,
	"./shared/forms/ReactSelect": 21,
	"./shared/forms/ReactSelect.tsx": 21,
	"./shared/forms/Select": 1952,
	"./shared/forms/Select.tsx": 1952,
	"./shared/forms/StandaloneDropzone": 511,
	"./shared/forms/StandaloneDropzone.tsx": 511,
	"./shared/forms/TinyMce": 442,
	"./shared/forms/TinyMce.tsx": 442,
	"./shared/forms/dropzone/uploadText": 379,
	"./shared/forms/dropzone/uploadText.tsx": 379,
	"./shared/forms/dropzone/uploadTextLarge": 614,
	"./shared/forms/dropzone/uploadTextLarge.tsx": 614,
	"./shared/forms/dropzone/uploading": 378,
	"./shared/forms/dropzone/uploading.tsx": 378,
	"./shared/forms/dropzone/uploadingLarge": 615,
	"./shared/forms/dropzone/uploadingLarge.tsx": 615,
	"./shared/graphitiTable/components/Header": 674,
	"./shared/graphitiTable/components/Header.tsx": 674,
	"./shared/graphitiTable/components/header/Button": 675,
	"./shared/graphitiTable/components/header/Button.tsx": 675,
	"./shared/graphitiTable/components/header/NewLink": 676,
	"./shared/graphitiTable/components/header/NewLink.tsx": 676,
	"./shared/investmentRestrictionsTable": 373,
	"./shared/investmentRestrictionsTable/": 373,
	"./shared/investmentRestrictionsTable/ActionPointCell": 645,
	"./shared/investmentRestrictionsTable/ActionPointCell.tsx": 645,
	"./shared/investmentRestrictionsTable/BreachIndicator": 387,
	"./shared/investmentRestrictionsTable/BreachIndicator.tsx": 387,
	"./shared/investmentRestrictionsTable/InvestmentRestrictionsTable": 385,
	"./shared/investmentRestrictionsTable/InvestmentRestrictionsTable.tsx": 385,
	"./shared/investmentRestrictionsTable/ResultCell": 646,
	"./shared/investmentRestrictionsTable/ResultCell.tsx": 646,
	"./shared/investmentRestrictionsTable/columns": 644,
	"./shared/investmentRestrictionsTable/columns.tsx": 644,
	"./shared/investmentRestrictionsTable/index": 373,
	"./shared/investmentRestrictionsTable/index.tsx": 373,
	"./shared/lastDateInQuarter": 240,
	"./shared/lastDateInQuarter.tsx": 240,
	"./shared/noteCards/Card": 870,
	"./shared/noteCards/Card.tsx": 870,
	"./shared/notes/ActionsDropdown": 739,
	"./shared/notes/ActionsDropdown.tsx": 739,
	"./shared/notes/Note": 506,
	"./shared/notes/Note.tsx": 506,
	"./shared/notes/Presenter": 404,
	"./shared/notes/Presenter.tsx": 404,
	"./shared/notes/body/Edit": 1136,
	"./shared/notes/body/Edit.tsx": 1136,
	"./shared/notes/body/View": 738,
	"./shared/notes/body/View-old": 1953,
	"./shared/notes/body/View-old.tsx": 1953,
	"./shared/notes/body/View.tsx": 738,
	"./shared/reactTable/CsvExport": 673,
	"./shared/reactTable/CsvExport.tsx": 673,
	"./shared/reactTable/IProps": 1954,
	"./shared/reactTable/IProps.tsx": 1954,
	"./shared/reactTable/OldCsvExport": 1133,
	"./shared/reactTable/OldCsvExport.tsx": 1133,
	"./shared/reactTable/Table": 64,
	"./shared/reactTable/Table.tsx": 64,
	"./shared/reactTable/components/Checkbox": 636,
	"./shared/reactTable/components/Checkbox.tsx": 636,
	"./shared/reactTable/components/ColumnFilter": 500,
	"./shared/reactTable/components/ColumnFilter.tsx": 500,
	"./shared/reactTable/components/ColumnSelector": 637,
	"./shared/reactTable/components/ColumnSelector.tsx": 637,
	"./shared/reactTable/components/HeaderCheckBox": 638,
	"./shared/reactTable/components/HeaderCheckBox.tsx": 638,
	"./shared/reactTable/components/HiddenNoDataComponent": 639,
	"./shared/reactTable/components/HiddenNoDataComponent.tsx": 639,
	"./shared/reactTable/components/HiddenPaginationComponent": 640,
	"./shared/reactTable/components/HiddenPaginationComponent.tsx": 640,
	"./shared/reactTable/components/LoadingComponent": 641,
	"./shared/reactTable/components/LoadingComponent.tsx": 641,
	"./shared/reactTable/components/NoDataComponent": 642,
	"./shared/reactTable/components/NoDataComponent.tsx": 642,
	"./shared/reactTable/components/PaginationComponent": 643,
	"./shared/reactTable/components/PaginationComponent.tsx": 643,
	"./shared/reactTable/utilities/processColumns": 635,
	"./shared/reactTable/utilities/processColumns.tsx": 635,
	"./shared/styledAlerts/StyledWarning": 179,
	"./shared/styledAlerts/StyledWarning.tsx": 179,
	"./shared/utilities/ajaxRequest": 202,
	"./shared/utilities/ajaxRequest.tsx": 202,
	"./shared/utilities/dateRange": 128,
	"./shared/utilities/dateRange.ts": 128,
	"./shared/utilities/getTicks": 243,
	"./shared/utilities/getTicks.tsx": 243,
	"./shared/utilities/labelNormalisation": 440,
	"./shared/utilities/labelNormalisation.tsx": 440,
	"./shared/utilities/precisionFunctions": 153,
	"./shared/utilities/precisionFunctions.tsx": 153,
	"./shared/utilities/range": 129,
	"./shared/utilities/range.tsx": 129,
	"./shared/utilities/simpleFormat": 1008,
	"./shared/utilities/simpleFormat.tsx": 1008,
	"./types/Cursor": 1955,
	"./types/Cursor.ts": 1955
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2383;